/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as DashboardRouteImport } from './routes/_dashboard'
import { Route as OnboardingRouteRouteImport } from './routes/onboarding/route'
import { Route as SignupRouteRouteImport } from './routes/signup/route'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthLogoutRouteImport } from './routes/_auth/logout'
import { Route as AuthNewPasswordRequiredRouteImport } from './routes/_auth/new-password-required'
import { Route as AuthSetupTotpRouteImport } from './routes/_auth/setup-totp'
import { Route as AuthSsoCallbackRouteImport } from './routes/_auth/sso-callback'
import { Route as DashboardActivityRouteRouteImport } from './routes/_dashboard/activity/route'
import { Route as DashboardCustomDashboardsRouteImport } from './routes/_dashboard/custom-dashboards'
import { Route as DashboardGraylogRouteImport } from './routes/_dashboard/graylog'
import { Route as DashboardHomeRouteImport } from './routes/_dashboard/home'
import { Route as DashboardIntegrationsRouteImport } from './routes/_dashboard/integrations'
import { Route as DashboardMdrRouteImport } from './routes/_dashboard/mdr'
import { Route as DashboardReportRouteRouteImport } from './routes/_dashboard/report/route'
import { Route as DashboardSettingsRouteImport } from './routes/_dashboard/settings'
import { Route as OnboardingSetupTotpRouteImport } from './routes/onboarding/setup-totp'
import { Route as SignupInviteRouteImport } from './routes/signup/invite'
import { Route as SignupSwitchAccountsRouteImport } from './routes/signup/switch-accounts'
import { Route as DashboardActionsIndexRouteImport } from './routes/_dashboard/actions.index'
import { Route as DashboardActivityIndexRouteImport } from './routes/_dashboard/activity/index'
import { Route as DashboardActivityActionsRouteImport } from './routes/_dashboard/activity/actions'
import { Route as DashboardActivityPlaybooksRouteImport } from './routes/_dashboard/activity/playbooks'
import { Route as DashboardAirLayoutRouteImport } from './routes/_dashboard/air/_layout'
import { Route as DashboardCustomDashboardsIndexRouteImport } from './routes/_dashboard/custom-dashboards.index'
import { Route as DashboardCustomDashboardsBuilderRouteImport } from './routes/_dashboard/custom-dashboards.builder'
import { Route as DashboardCustomDashboardsLibraryRouteImport } from './routes/_dashboard/custom-dashboards.library'
import { Route as DashboardDevKitchenSinkRouteImport } from './routes/_dashboard/dev/kitchen-sink'
import { Route as DashboardGraylogIndexRouteImport } from './routes/_dashboard/graylog/index'
import { Route as DashboardGraylogAlertsRouteImport } from './routes/_dashboard/graylog/alerts'
import { Route as DashboardGraylogTriggeredAlertsRouteImport } from './routes/_dashboard/graylog/triggered-alerts'
import { Route as DashboardIntegrationsIndexRouteImport } from './routes/_dashboard/integrations/index'
import { Route as DashboardMdrIndexRouteImport } from './routes/_dashboard/mdr/index'
import { Route as DashboardMdrExecutiveReportsRouteImport } from './routes/_dashboard/mdr/executive-reports'
import { Route as DashboardMultiTenantLayoutRouteImport } from './routes/_dashboard/multi-tenant/_layout'
import { Route as DashboardPlaybooksIndexRouteImport } from './routes/_dashboard/playbooks/index'
import { Route as DashboardPlaybooksIdRouteImport } from './routes/_dashboard/playbooks/$id'
import { Route as DashboardReportAirRouteImport } from './routes/_dashboard/report/air'
import { Route as DashboardReportGraylogRouteImport } from './routes/_dashboard/report/graylog'
import { Route as DashboardSearchIndexRouteImport } from './routes/_dashboard/search.index'
import { Route as DashboardSettingsIndexRouteImport } from './routes/_dashboard/settings/index'
import { Route as DashboardSettingsNotificationsRouteImport } from './routes/_dashboard/settings/notifications'
import { Route as DashboardSettingsProfileRouteImport } from './routes/_dashboard/settings/profile'
import { Route as DashboardSettingsTenantSettingsRouteImport } from './routes/_dashboard/settings/tenant-settings'
import { Route as DashboardUnauthorizedIndexRouteImport } from './routes/_dashboard/unauthorized.index'
import { Route as SignupAzureIndexRouteImport } from './routes/signup/azure/index'
import { Route as SignupAzureCallbackRouteImport } from './routes/signup/azure/callback'
import { Route as SignupAzureConfirmRouteImport } from './routes/signup/azure/confirm'
import { Route as DashboardAirLayoutIndexRouteImport } from './routes/_dashboard/air/_layout.index'
import { Route as DashboardAirLayoutAutomationSettingsRouteImport } from './routes/_dashboard/air/_layout.automation-settings'
import { Route as DashboardAirLayoutCaseManagementRouteImport } from './routes/_dashboard/air/_layout.case-management'
import { Route as DashboardAirLayoutOverviewRouteImport } from './routes/_dashboard/air/_layout.overview'
import { Route as DashboardAirLayoutPolicyManagementRouteImport } from './routes/_dashboard/air/_layout.policy-management'
import { Route as DashboardAirAutomationSettingsMapping_idRouteImport } from './routes/_dashboard/air/automation-settings.$mapping_id'
import { Route as DashboardAirAutomationSettingsNewRouteImport } from './routes/_dashboard/air/automation-settings.new'
import { Route as DashboardAirCaseManagementIdRouteImport } from './routes/_dashboard/air/case-management.$id'
import { Route as DashboardAirPolicyManagementPolicyIdRouteImport } from './routes/_dashboard/air/policy-management.$policyId'
import { Route as DashboardAirPolicyManagementNewRouteImport } from './routes/_dashboard/air/policy-management.new'
import { Route as DashboardGraylogAutomationSettingsIndexRouteImport } from './routes/_dashboard/graylog/automation-settings.index'
import { Route as DashboardGraylogEventDefinitionsIndexRouteImport } from './routes/_dashboard/graylog/event-definitions.index'
import { Route as DashboardIntegrationsCloudIndexRouteImport } from './routes/_dashboard/integrations/cloud.index'
import { Route as DashboardIntegrationsCloudIdRouteImport } from './routes/_dashboard/integrations/cloud.$id'
import { Route as DashboardIntegrationsCollectorsIndexRouteImport } from './routes/_dashboard/integrations/collectors.index'
import { Route as DashboardIntegrationsCollectorsNewRouteImport } from './routes/_dashboard/integrations/collectors.new'
import { Route as DashboardIntegrationsNewIndexRouteImport } from './routes/_dashboard/integrations/new.index'
import { Route as DashboardIntegrationsNewIdRouteImport } from './routes/_dashboard/integrations/new.$id'
import { Route as DashboardIntegrationsNewCallbackRouteImport } from './routes/_dashboard/integrations/new.callback'
import { Route as DashboardMultiTenantLayoutIndexRouteImport } from './routes/_dashboard/multi-tenant/_layout.index'
import { Route as DashboardMultiTenantLayoutAutomationsRouteImport } from './routes/_dashboard/multi-tenant/_layout.automations'
import { Route as DashboardMultiTenantLayoutCasesRouteImport } from './routes/_dashboard/multi-tenant/_layout.cases'
import { Route as DashboardMultiTenantLayoutPoliciesRouteImport } from './routes/_dashboard/multi-tenant/_layout.policies'
import { Route as DashboardSettingsTenantSettingsApiKeysRouteImport } from './routes/_dashboard/settings/tenant-settings.api-keys'
import { Route as DashboardSettingsTenantSettingsAuthenticationRouteImport } from './routes/_dashboard/settings/tenant-settings.authentication'
import { Route as DashboardSettingsTenantSettingsInvitationsRouteImport } from './routes/_dashboard/settings/tenant-settings.invitations'
import { Route as DashboardSettingsTenantSettingsMembersRouteImport } from './routes/_dashboard/settings/tenant-settings.members'
import { Route as DashboardSettingsTenantSettingsNotificationRecipientsRouteImport } from './routes/_dashboard/settings/tenant-settings.notification-recipients'
import { Route as DashboardAirCaseManagementIdIndexRouteImport } from './routes/_dashboard/air/case-management.$id.index'
import { Route as DashboardAirCaseManagementIdAutomationRouteImport } from './routes/_dashboard/air/case-management.$id.automation'
import { Route as DashboardAirCaseManagementIdBehaviorRouteImport } from './routes/_dashboard/air/case-management.$id.behavior'
import { Route as DashboardAirCaseManagementIdCaseDetailsRouteImport } from './routes/_dashboard/air/case-management.$id.case-details'
import { Route as DashboardAirCaseManagementIdDiscussionRouteImport } from './routes/_dashboard/air/case-management.$id.discussion'
import { Route as DashboardAirCaseManagementIdEvidenceRouteImport } from './routes/_dashboard/air/case-management.$id.evidence'
import { Route as DashboardAirCaseManagementIdInvestigationStepsRouteImport } from './routes/_dashboard/air/case-management.$id.investigation-steps'
import { Route as DashboardAirCaseManagementIdLogsRouteImport } from './routes/_dashboard/air/case-management.$id.logs'
import { Route as DashboardAirCaseManagementIdOverviewRouteImport } from './routes/_dashboard/air/case-management.$id.overview'
import { Route as DashboardGraylogAutomationSettingsEditIdRouteImport } from './routes/_dashboard/graylog/automation-settings.edit.$id'
import { Route as DashboardGraylogAutomationSettingsNewIndexRouteImport } from './routes/_dashboard/graylog/automation-settings.new.index'
import { Route as DashboardIntegrationsCollectorsCollectorIdIndexRouteImport } from './routes/_dashboard/integrations/collectors.$collectorId.index'
import { Route as DashboardIntegrationsCollectorsCollectorIdSourceIdRouteImport } from './routes/_dashboard/integrations/collectors.$collectorId.$sourceId'
import { Route as DashboardIntegrationsCollectorsSourcesNewDefinitionIdRouteImport } from './routes/_dashboard/integrations/collectors.sources.new.$definitionId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRouteRoute = OnboardingRouteRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRouteRoute = SignupRouteRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLogoutRoute = AuthLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => AuthRoute,
} as any)
const AuthNewPasswordRequiredRoute = AuthNewPasswordRequiredRouteImport.update({
  id: '/new-password-required',
  path: '/new-password-required',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSetupTotpRoute = AuthSetupTotpRouteImport.update({
  id: '/setup-totp',
  path: '/setup-totp',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSsoCallbackRoute = AuthSsoCallbackRouteImport.update({
  id: '/sso-callback',
  path: '/sso-callback',
  getParentRoute: () => AuthRoute,
} as any)
const DashboardActivityRouteRoute = DashboardActivityRouteRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCustomDashboardsRoute =
  DashboardCustomDashboardsRouteImport.update({
    id: '/custom-dashboards',
    path: '/custom-dashboards',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardGraylogRoute = DashboardGraylogRouteImport.update({
  id: '/graylog',
  path: '/graylog',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardHomeRoute = DashboardHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardIntegrationsRoute = DashboardIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardMdrRoute = DashboardMdrRouteImport.update({
  id: '/mdr',
  path: '/mdr',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardReportRouteRoute = DashboardReportRouteRouteImport.update({
  id: '/report',
  path: '/report',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashboardRoute,
} as any)
const OnboardingSetupTotpRoute = OnboardingSetupTotpRouteImport.update({
  id: '/setup-totp',
  path: '/setup-totp',
  getParentRoute: () => OnboardingRouteRoute,
} as any)
const SignupInviteRoute = SignupInviteRouteImport.update({
  id: '/invite',
  path: '/invite',
  getParentRoute: () => SignupRouteRoute,
} as any)
const SignupSwitchAccountsRoute = SignupSwitchAccountsRouteImport.update({
  id: '/switch-accounts',
  path: '/switch-accounts',
  getParentRoute: () => SignupRouteRoute,
} as any)
const DashboardActionsIndexRoute = DashboardActionsIndexRouteImport.update({
  id: '/actions/',
  path: '/actions/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardActivityIndexRoute = DashboardActivityIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardActivityRouteRoute,
} as any)
const DashboardActivityActionsRoute =
  DashboardActivityActionsRouteImport.update({
    id: '/actions',
    path: '/actions',
    getParentRoute: () => DashboardActivityRouteRoute,
  } as any)
const DashboardActivityPlaybooksRoute =
  DashboardActivityPlaybooksRouteImport.update({
    id: '/playbooks',
    path: '/playbooks',
    getParentRoute: () => DashboardActivityRouteRoute,
  } as any)
const DashboardAirLayoutRoute = DashboardAirLayoutRouteImport.update({
  id: '/air/_layout',
  path: '/air',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCustomDashboardsIndexRoute =
  DashboardCustomDashboardsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardCustomDashboardsRoute,
  } as any)
const DashboardCustomDashboardsBuilderRoute =
  DashboardCustomDashboardsBuilderRouteImport.update({
    id: '/builder',
    path: '/builder',
    getParentRoute: () => DashboardCustomDashboardsRoute,
  } as any)
const DashboardCustomDashboardsLibraryRoute =
  DashboardCustomDashboardsLibraryRouteImport.update({
    id: '/library',
    path: '/library',
    getParentRoute: () => DashboardCustomDashboardsRoute,
  } as any)
const DashboardDevKitchenSinkRoute = DashboardDevKitchenSinkRouteImport.update({
  id: '/dev/kitchen-sink',
  path: '/dev/kitchen-sink',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardGraylogIndexRoute = DashboardGraylogIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardGraylogRoute,
} as any)
const DashboardGraylogAlertsRoute = DashboardGraylogAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => DashboardGraylogRoute,
} as any)
const DashboardGraylogTriggeredAlertsRoute =
  DashboardGraylogTriggeredAlertsRouteImport.update({
    id: '/triggered-alerts',
    path: '/triggered-alerts',
    getParentRoute: () => DashboardGraylogRoute,
  } as any)
const DashboardIntegrationsIndexRoute =
  DashboardIntegrationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardIntegrationsRoute,
  } as any)
const DashboardMdrIndexRoute = DashboardMdrIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardMdrRoute,
} as any)
const DashboardMdrExecutiveReportsRoute =
  DashboardMdrExecutiveReportsRouteImport.update({
    id: '/executive-reports',
    path: '/executive-reports',
    getParentRoute: () => DashboardMdrRoute,
  } as any)
const DashboardMultiTenantLayoutRoute =
  DashboardMultiTenantLayoutRouteImport.update({
    id: '/multi-tenant/_layout',
    path: '/multi-tenant',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardPlaybooksIndexRoute = DashboardPlaybooksIndexRouteImport.update({
  id: '/playbooks/',
  path: '/playbooks/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardPlaybooksIdRoute = DashboardPlaybooksIdRouteImport.update({
  id: '/playbooks/$id',
  path: '/playbooks/$id',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardReportAirRoute = DashboardReportAirRouteImport.update({
  id: '/air',
  path: '/air',
  getParentRoute: () => DashboardReportRouteRoute,
} as any)
const DashboardReportGraylogRoute = DashboardReportGraylogRouteImport.update({
  id: '/graylog',
  path: '/graylog',
  getParentRoute: () => DashboardReportRouteRoute,
} as any)
const DashboardSearchIndexRoute = DashboardSearchIndexRouteImport.update({
  id: '/search/',
  path: '/search/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSettingsIndexRoute = DashboardSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardSettingsRoute,
} as any)
const DashboardSettingsNotificationsRoute =
  DashboardSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => DashboardSettingsRoute,
  } as any)
const DashboardSettingsProfileRoute =
  DashboardSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => DashboardSettingsRoute,
  } as any)
const DashboardSettingsTenantSettingsRoute =
  DashboardSettingsTenantSettingsRouteImport.update({
    id: '/tenant-settings',
    path: '/tenant-settings',
    getParentRoute: () => DashboardSettingsRoute,
  } as any)
const DashboardUnauthorizedIndexRoute =
  DashboardUnauthorizedIndexRouteImport.update({
    id: '/unauthorized/',
    path: '/unauthorized/',
    getParentRoute: () => DashboardRoute,
  } as any)
const SignupAzureIndexRoute = SignupAzureIndexRouteImport.update({
  id: '/azure/',
  path: '/azure/',
  getParentRoute: () => SignupRouteRoute,
} as any)
const SignupAzureCallbackRoute = SignupAzureCallbackRouteImport.update({
  id: '/azure/callback',
  path: '/azure/callback',
  getParentRoute: () => SignupRouteRoute,
} as any)
const SignupAzureConfirmRoute = SignupAzureConfirmRouteImport.update({
  id: '/azure/confirm',
  path: '/azure/confirm',
  getParentRoute: () => SignupRouteRoute,
} as any)
const DashboardAirLayoutIndexRoute = DashboardAirLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardAirLayoutRoute,
} as any)
const DashboardAirLayoutAutomationSettingsRoute =
  DashboardAirLayoutAutomationSettingsRouteImport.update({
    id: '/automation-settings',
    path: '/automation-settings',
    getParentRoute: () => DashboardAirLayoutRoute,
  } as any)
const DashboardAirLayoutCaseManagementRoute =
  DashboardAirLayoutCaseManagementRouteImport.update({
    id: '/case-management',
    path: '/case-management',
    getParentRoute: () => DashboardAirLayoutRoute,
  } as any)
const DashboardAirLayoutOverviewRoute =
  DashboardAirLayoutOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardAirLayoutRoute,
  } as any)
const DashboardAirLayoutPolicyManagementRoute =
  DashboardAirLayoutPolicyManagementRouteImport.update({
    id: '/policy-management',
    path: '/policy-management',
    getParentRoute: () => DashboardAirLayoutRoute,
  } as any)
const DashboardAirAutomationSettingsMapping_idRoute =
  DashboardAirAutomationSettingsMapping_idRouteImport.update({
    id: '/air/automation-settings/$mapping_id',
    path: '/air/automation-settings/$mapping_id',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAirAutomationSettingsNewRoute =
  DashboardAirAutomationSettingsNewRouteImport.update({
    id: '/air/automation-settings/new',
    path: '/air/automation-settings/new',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAirCaseManagementIdRoute =
  DashboardAirCaseManagementIdRouteImport.update({
    id: '/air/case-management/$id',
    path: '/air/case-management/$id',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAirPolicyManagementPolicyIdRoute =
  DashboardAirPolicyManagementPolicyIdRouteImport.update({
    id: '/air/policy-management/$policyId',
    path: '/air/policy-management/$policyId',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardAirPolicyManagementNewRoute =
  DashboardAirPolicyManagementNewRouteImport.update({
    id: '/air/policy-management/new',
    path: '/air/policy-management/new',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardGraylogAutomationSettingsIndexRoute =
  DashboardGraylogAutomationSettingsIndexRouteImport.update({
    id: '/automation-settings/',
    path: '/automation-settings/',
    getParentRoute: () => DashboardGraylogRoute,
  } as any)
const DashboardGraylogEventDefinitionsIndexRoute =
  DashboardGraylogEventDefinitionsIndexRouteImport.update({
    id: '/event-definitions/',
    path: '/event-definitions/',
    getParentRoute: () => DashboardGraylogRoute,
  } as any)
const DashboardIntegrationsCloudIndexRoute =
  DashboardIntegrationsCloudIndexRouteImport.update({
    id: '/cloud/',
    path: '/cloud/',
    getParentRoute: () => DashboardIntegrationsRoute,
  } as any)
const DashboardIntegrationsCloudIdRoute =
  DashboardIntegrationsCloudIdRouteImport.update({
    id: '/cloud/$id',
    path: '/cloud/$id',
    getParentRoute: () => DashboardIntegrationsRoute,
  } as any)
const DashboardIntegrationsCollectorsIndexRoute =
  DashboardIntegrationsCollectorsIndexRouteImport.update({
    id: '/collectors/',
    path: '/collectors/',
    getParentRoute: () => DashboardIntegrationsRoute,
  } as any)
const DashboardIntegrationsCollectorsNewRoute =
  DashboardIntegrationsCollectorsNewRouteImport.update({
    id: '/collectors/new',
    path: '/collectors/new',
    getParentRoute: () => DashboardIntegrationsRoute,
  } as any)
const DashboardIntegrationsNewIndexRoute =
  DashboardIntegrationsNewIndexRouteImport.update({
    id: '/new/',
    path: '/new/',
    getParentRoute: () => DashboardIntegrationsRoute,
  } as any)
const DashboardIntegrationsNewIdRoute =
  DashboardIntegrationsNewIdRouteImport.update({
    id: '/new/$id',
    path: '/new/$id',
    getParentRoute: () => DashboardIntegrationsRoute,
  } as any)
const DashboardIntegrationsNewCallbackRoute =
  DashboardIntegrationsNewCallbackRouteImport.update({
    id: '/new/callback',
    path: '/new/callback',
    getParentRoute: () => DashboardIntegrationsRoute,
  } as any)
const DashboardMultiTenantLayoutIndexRoute =
  DashboardMultiTenantLayoutIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardMultiTenantLayoutRoute,
  } as any)
const DashboardMultiTenantLayoutAutomationsRoute =
  DashboardMultiTenantLayoutAutomationsRouteImport.update({
    id: '/automations',
    path: '/automations',
    getParentRoute: () => DashboardMultiTenantLayoutRoute,
  } as any)
const DashboardMultiTenantLayoutCasesRoute =
  DashboardMultiTenantLayoutCasesRouteImport.update({
    id: '/cases',
    path: '/cases',
    getParentRoute: () => DashboardMultiTenantLayoutRoute,
  } as any)
const DashboardMultiTenantLayoutPoliciesRoute =
  DashboardMultiTenantLayoutPoliciesRouteImport.update({
    id: '/policies',
    path: '/policies',
    getParentRoute: () => DashboardMultiTenantLayoutRoute,
  } as any)
const DashboardSettingsTenantSettingsApiKeysRoute =
  DashboardSettingsTenantSettingsApiKeysRouteImport.update({
    id: '/api-keys',
    path: '/api-keys',
    getParentRoute: () => DashboardSettingsTenantSettingsRoute,
  } as any)
const DashboardSettingsTenantSettingsAuthenticationRoute =
  DashboardSettingsTenantSettingsAuthenticationRouteImport.update({
    id: '/authentication',
    path: '/authentication',
    getParentRoute: () => DashboardSettingsTenantSettingsRoute,
  } as any)
const DashboardSettingsTenantSettingsInvitationsRoute =
  DashboardSettingsTenantSettingsInvitationsRouteImport.update({
    id: '/invitations',
    path: '/invitations',
    getParentRoute: () => DashboardSettingsTenantSettingsRoute,
  } as any)
const DashboardSettingsTenantSettingsMembersRoute =
  DashboardSettingsTenantSettingsMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => DashboardSettingsTenantSettingsRoute,
  } as any)
const DashboardSettingsTenantSettingsNotificationRecipientsRoute =
  DashboardSettingsTenantSettingsNotificationRecipientsRouteImport.update({
    id: '/notification-recipients',
    path: '/notification-recipients',
    getParentRoute: () => DashboardSettingsTenantSettingsRoute,
  } as any)
const DashboardAirCaseManagementIdIndexRoute =
  DashboardAirCaseManagementIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardAirCaseManagementIdRoute,
  } as any)
const DashboardAirCaseManagementIdAutomationRoute =
  DashboardAirCaseManagementIdAutomationRouteImport.update({
    id: '/automation',
    path: '/automation',
    getParentRoute: () => DashboardAirCaseManagementIdRoute,
  } as any)
const DashboardAirCaseManagementIdBehaviorRoute =
  DashboardAirCaseManagementIdBehaviorRouteImport.update({
    id: '/behavior',
    path: '/behavior',
    getParentRoute: () => DashboardAirCaseManagementIdRoute,
  } as any)
const DashboardAirCaseManagementIdCaseDetailsRoute =
  DashboardAirCaseManagementIdCaseDetailsRouteImport.update({
    id: '/case-details',
    path: '/case-details',
    getParentRoute: () => DashboardAirCaseManagementIdRoute,
  } as any)
const DashboardAirCaseManagementIdDiscussionRoute =
  DashboardAirCaseManagementIdDiscussionRouteImport.update({
    id: '/discussion',
    path: '/discussion',
    getParentRoute: () => DashboardAirCaseManagementIdRoute,
  } as any)
const DashboardAirCaseManagementIdEvidenceRoute =
  DashboardAirCaseManagementIdEvidenceRouteImport.update({
    id: '/evidence',
    path: '/evidence',
    getParentRoute: () => DashboardAirCaseManagementIdRoute,
  } as any)
const DashboardAirCaseManagementIdInvestigationStepsRoute =
  DashboardAirCaseManagementIdInvestigationStepsRouteImport.update({
    id: '/investigation-steps',
    path: '/investigation-steps',
    getParentRoute: () => DashboardAirCaseManagementIdRoute,
  } as any)
const DashboardAirCaseManagementIdLogsRoute =
  DashboardAirCaseManagementIdLogsRouteImport.update({
    id: '/logs',
    path: '/logs',
    getParentRoute: () => DashboardAirCaseManagementIdRoute,
  } as any)
const DashboardAirCaseManagementIdOverviewRoute =
  DashboardAirCaseManagementIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardAirCaseManagementIdRoute,
  } as any)
const DashboardGraylogAutomationSettingsEditIdRoute =
  DashboardGraylogAutomationSettingsEditIdRouteImport.update({
    id: '/automation-settings/edit/$id',
    path: '/automation-settings/edit/$id',
    getParentRoute: () => DashboardGraylogRoute,
  } as any)
const DashboardGraylogAutomationSettingsNewIndexRoute =
  DashboardGraylogAutomationSettingsNewIndexRouteImport.update({
    id: '/automation-settings/new/',
    path: '/automation-settings/new/',
    getParentRoute: () => DashboardGraylogRoute,
  } as any)
const DashboardIntegrationsCollectorsCollectorIdIndexRoute =
  DashboardIntegrationsCollectorsCollectorIdIndexRouteImport.update({
    id: '/collectors/$collectorId/',
    path: '/collectors/$collectorId/',
    getParentRoute: () => DashboardIntegrationsRoute,
  } as any)
const DashboardIntegrationsCollectorsCollectorIdSourceIdRoute =
  DashboardIntegrationsCollectorsCollectorIdSourceIdRouteImport.update({
    id: '/collectors/$collectorId/$sourceId',
    path: '/collectors/$collectorId/$sourceId',
    getParentRoute: () => DashboardIntegrationsRoute,
  } as any)
const DashboardIntegrationsCollectorsSourcesNewDefinitionIdRoute =
  DashboardIntegrationsCollectorsSourcesNewDefinitionIdRouteImport.update({
    id: '/collectors/sources/new/$definitionId',
    path: '/collectors/sources/new/$definitionId',
    getParentRoute: () => DashboardIntegrationsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRouteRouteWithChildren
  '/signup': typeof SignupRouteRouteWithChildren
  '/activity': typeof DashboardActivityRouteRouteWithChildren
  '/report': typeof DashboardReportRouteRouteWithChildren
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/logout': typeof AuthLogoutRoute
  '/new-password-required': typeof AuthNewPasswordRequiredRoute
  '/setup-totp': typeof AuthSetupTotpRoute
  '/sso-callback': typeof AuthSsoCallbackRoute
  '/custom-dashboards': typeof DashboardCustomDashboardsRouteWithChildren
  '/graylog': typeof DashboardGraylogRouteWithChildren
  '/home': typeof DashboardHomeRoute
  '/integrations': typeof DashboardIntegrationsRouteWithChildren
  '/mdr': typeof DashboardMdrRouteWithChildren
  '/settings': typeof DashboardSettingsRouteWithChildren
  '/onboarding/setup-totp': typeof OnboardingSetupTotpRoute
  '/signup/invite': typeof SignupInviteRoute
  '/signup/switch-accounts': typeof SignupSwitchAccountsRoute
  '/activity/actions': typeof DashboardActivityActionsRoute
  '/activity/playbooks': typeof DashboardActivityPlaybooksRoute
  '/air': typeof DashboardAirLayoutRouteWithChildren
  '/custom-dashboards/builder': typeof DashboardCustomDashboardsBuilderRoute
  '/custom-dashboards/library': typeof DashboardCustomDashboardsLibraryRoute
  '/dev/kitchen-sink': typeof DashboardDevKitchenSinkRoute
  '/graylog/alerts': typeof DashboardGraylogAlertsRoute
  '/graylog/triggered-alerts': typeof DashboardGraylogTriggeredAlertsRoute
  '/mdr/executive-reports': typeof DashboardMdrExecutiveReportsRoute
  '/multi-tenant': typeof DashboardMultiTenantLayoutRouteWithChildren
  '/playbooks/$id': typeof DashboardPlaybooksIdRoute
  '/report/air': typeof DashboardReportAirRoute
  '/report/graylog': typeof DashboardReportGraylogRoute
  '/settings/notifications': typeof DashboardSettingsNotificationsRoute
  '/settings/profile': typeof DashboardSettingsProfileRoute
  '/settings/tenant-settings': typeof DashboardSettingsTenantSettingsRouteWithChildren
  '/signup/azure/callback': typeof SignupAzureCallbackRoute
  '/signup/azure/confirm': typeof SignupAzureConfirmRoute
  '/actions/': typeof DashboardActionsIndexRoute
  '/activity/': typeof DashboardActivityIndexRoute
  '/custom-dashboards/': typeof DashboardCustomDashboardsIndexRoute
  '/graylog/': typeof DashboardGraylogIndexRoute
  '/integrations/': typeof DashboardIntegrationsIndexRoute
  '/mdr/': typeof DashboardMdrIndexRoute
  '/playbooks/': typeof DashboardPlaybooksIndexRoute
  '/search/': typeof DashboardSearchIndexRoute
  '/settings/': typeof DashboardSettingsIndexRoute
  '/unauthorized/': typeof DashboardUnauthorizedIndexRoute
  '/signup/azure/': typeof SignupAzureIndexRoute
  '/air/automation-settings': typeof DashboardAirLayoutAutomationSettingsRoute
  '/air/case-management': typeof DashboardAirLayoutCaseManagementRoute
  '/air/overview': typeof DashboardAirLayoutOverviewRoute
  '/air/policy-management': typeof DashboardAirLayoutPolicyManagementRoute
  '/air/automation-settings/$mapping_id': typeof DashboardAirAutomationSettingsMapping_idRoute
  '/air/automation-settings/new': typeof DashboardAirAutomationSettingsNewRoute
  '/air/case-management/$id': typeof DashboardAirCaseManagementIdRouteWithChildren
  '/air/policy-management/$policyId': typeof DashboardAirPolicyManagementPolicyIdRoute
  '/air/policy-management/new': typeof DashboardAirPolicyManagementNewRoute
  '/integrations/cloud/$id': typeof DashboardIntegrationsCloudIdRoute
  '/integrations/collectors/new': typeof DashboardIntegrationsCollectorsNewRoute
  '/integrations/new/$id': typeof DashboardIntegrationsNewIdRoute
  '/integrations/new/callback': typeof DashboardIntegrationsNewCallbackRoute
  '/multi-tenant/automations': typeof DashboardMultiTenantLayoutAutomationsRoute
  '/multi-tenant/cases': typeof DashboardMultiTenantLayoutCasesRoute
  '/multi-tenant/policies': typeof DashboardMultiTenantLayoutPoliciesRoute
  '/settings/tenant-settings/api-keys': typeof DashboardSettingsTenantSettingsApiKeysRoute
  '/settings/tenant-settings/authentication': typeof DashboardSettingsTenantSettingsAuthenticationRoute
  '/settings/tenant-settings/invitations': typeof DashboardSettingsTenantSettingsInvitationsRoute
  '/settings/tenant-settings/members': typeof DashboardSettingsTenantSettingsMembersRoute
  '/settings/tenant-settings/notification-recipients': typeof DashboardSettingsTenantSettingsNotificationRecipientsRoute
  '/air/': typeof DashboardAirLayoutIndexRoute
  '/graylog/automation-settings/': typeof DashboardGraylogAutomationSettingsIndexRoute
  '/graylog/event-definitions/': typeof DashboardGraylogEventDefinitionsIndexRoute
  '/integrations/cloud/': typeof DashboardIntegrationsCloudIndexRoute
  '/integrations/collectors/': typeof DashboardIntegrationsCollectorsIndexRoute
  '/integrations/new/': typeof DashboardIntegrationsNewIndexRoute
  '/multi-tenant/': typeof DashboardMultiTenantLayoutIndexRoute
  '/air/case-management/$id/automation': typeof DashboardAirCaseManagementIdAutomationRoute
  '/air/case-management/$id/behavior': typeof DashboardAirCaseManagementIdBehaviorRoute
  '/air/case-management/$id/case-details': typeof DashboardAirCaseManagementIdCaseDetailsRoute
  '/air/case-management/$id/discussion': typeof DashboardAirCaseManagementIdDiscussionRoute
  '/air/case-management/$id/evidence': typeof DashboardAirCaseManagementIdEvidenceRoute
  '/air/case-management/$id/investigation-steps': typeof DashboardAirCaseManagementIdInvestigationStepsRoute
  '/air/case-management/$id/logs': typeof DashboardAirCaseManagementIdLogsRoute
  '/air/case-management/$id/overview': typeof DashboardAirCaseManagementIdOverviewRoute
  '/graylog/automation-settings/edit/$id': typeof DashboardGraylogAutomationSettingsEditIdRoute
  '/integrations/collectors/$collectorId/$sourceId': typeof DashboardIntegrationsCollectorsCollectorIdSourceIdRoute
  '/air/case-management/$id/': typeof DashboardAirCaseManagementIdIndexRoute
  '/graylog/automation-settings/new/': typeof DashboardGraylogAutomationSettingsNewIndexRoute
  '/integrations/collectors/$collectorId/': typeof DashboardIntegrationsCollectorsCollectorIdIndexRoute
  '/integrations/collectors/sources/new/$definitionId': typeof DashboardIntegrationsCollectorsSourcesNewDefinitionIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRouteRouteWithChildren
  '/signup': typeof SignupRouteRouteWithChildren
  '/report': typeof DashboardReportRouteRouteWithChildren
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/logout': typeof AuthLogoutRoute
  '/new-password-required': typeof AuthNewPasswordRequiredRoute
  '/setup-totp': typeof AuthSetupTotpRoute
  '/sso-callback': typeof AuthSsoCallbackRoute
  '/home': typeof DashboardHomeRoute
  '/onboarding/setup-totp': typeof OnboardingSetupTotpRoute
  '/signup/invite': typeof SignupInviteRoute
  '/signup/switch-accounts': typeof SignupSwitchAccountsRoute
  '/activity/actions': typeof DashboardActivityActionsRoute
  '/activity/playbooks': typeof DashboardActivityPlaybooksRoute
  '/custom-dashboards/builder': typeof DashboardCustomDashboardsBuilderRoute
  '/custom-dashboards/library': typeof DashboardCustomDashboardsLibraryRoute
  '/dev/kitchen-sink': typeof DashboardDevKitchenSinkRoute
  '/graylog/alerts': typeof DashboardGraylogAlertsRoute
  '/graylog/triggered-alerts': typeof DashboardGraylogTriggeredAlertsRoute
  '/mdr/executive-reports': typeof DashboardMdrExecutiveReportsRoute
  '/playbooks/$id': typeof DashboardPlaybooksIdRoute
  '/report/air': typeof DashboardReportAirRoute
  '/report/graylog': typeof DashboardReportGraylogRoute
  '/settings/notifications': typeof DashboardSettingsNotificationsRoute
  '/settings/profile': typeof DashboardSettingsProfileRoute
  '/settings/tenant-settings': typeof DashboardSettingsTenantSettingsRouteWithChildren
  '/signup/azure/callback': typeof SignupAzureCallbackRoute
  '/signup/azure/confirm': typeof SignupAzureConfirmRoute
  '/actions': typeof DashboardActionsIndexRoute
  '/activity': typeof DashboardActivityIndexRoute
  '/custom-dashboards': typeof DashboardCustomDashboardsIndexRoute
  '/graylog': typeof DashboardGraylogIndexRoute
  '/integrations': typeof DashboardIntegrationsIndexRoute
  '/mdr': typeof DashboardMdrIndexRoute
  '/playbooks': typeof DashboardPlaybooksIndexRoute
  '/search': typeof DashboardSearchIndexRoute
  '/settings': typeof DashboardSettingsIndexRoute
  '/unauthorized': typeof DashboardUnauthorizedIndexRoute
  '/signup/azure': typeof SignupAzureIndexRoute
  '/air/automation-settings': typeof DashboardAirLayoutAutomationSettingsRoute
  '/air/case-management': typeof DashboardAirLayoutCaseManagementRoute
  '/air/overview': typeof DashboardAirLayoutOverviewRoute
  '/air/policy-management': typeof DashboardAirLayoutPolicyManagementRoute
  '/air/automation-settings/$mapping_id': typeof DashboardAirAutomationSettingsMapping_idRoute
  '/air/automation-settings/new': typeof DashboardAirAutomationSettingsNewRoute
  '/air/policy-management/$policyId': typeof DashboardAirPolicyManagementPolicyIdRoute
  '/air/policy-management/new': typeof DashboardAirPolicyManagementNewRoute
  '/integrations/cloud/$id': typeof DashboardIntegrationsCloudIdRoute
  '/integrations/collectors/new': typeof DashboardIntegrationsCollectorsNewRoute
  '/integrations/new/$id': typeof DashboardIntegrationsNewIdRoute
  '/integrations/new/callback': typeof DashboardIntegrationsNewCallbackRoute
  '/multi-tenant/automations': typeof DashboardMultiTenantLayoutAutomationsRoute
  '/multi-tenant/cases': typeof DashboardMultiTenantLayoutCasesRoute
  '/multi-tenant/policies': typeof DashboardMultiTenantLayoutPoliciesRoute
  '/settings/tenant-settings/api-keys': typeof DashboardSettingsTenantSettingsApiKeysRoute
  '/settings/tenant-settings/authentication': typeof DashboardSettingsTenantSettingsAuthenticationRoute
  '/settings/tenant-settings/invitations': typeof DashboardSettingsTenantSettingsInvitationsRoute
  '/settings/tenant-settings/members': typeof DashboardSettingsTenantSettingsMembersRoute
  '/settings/tenant-settings/notification-recipients': typeof DashboardSettingsTenantSettingsNotificationRecipientsRoute
  '/air': typeof DashboardAirLayoutIndexRoute
  '/graylog/automation-settings': typeof DashboardGraylogAutomationSettingsIndexRoute
  '/graylog/event-definitions': typeof DashboardGraylogEventDefinitionsIndexRoute
  '/integrations/cloud': typeof DashboardIntegrationsCloudIndexRoute
  '/integrations/collectors': typeof DashboardIntegrationsCollectorsIndexRoute
  '/integrations/new': typeof DashboardIntegrationsNewIndexRoute
  '/multi-tenant': typeof DashboardMultiTenantLayoutIndexRoute
  '/air/case-management/$id/automation': typeof DashboardAirCaseManagementIdAutomationRoute
  '/air/case-management/$id/behavior': typeof DashboardAirCaseManagementIdBehaviorRoute
  '/air/case-management/$id/case-details': typeof DashboardAirCaseManagementIdCaseDetailsRoute
  '/air/case-management/$id/discussion': typeof DashboardAirCaseManagementIdDiscussionRoute
  '/air/case-management/$id/evidence': typeof DashboardAirCaseManagementIdEvidenceRoute
  '/air/case-management/$id/investigation-steps': typeof DashboardAirCaseManagementIdInvestigationStepsRoute
  '/air/case-management/$id/logs': typeof DashboardAirCaseManagementIdLogsRoute
  '/air/case-management/$id/overview': typeof DashboardAirCaseManagementIdOverviewRoute
  '/graylog/automation-settings/edit/$id': typeof DashboardGraylogAutomationSettingsEditIdRoute
  '/integrations/collectors/$collectorId/$sourceId': typeof DashboardIntegrationsCollectorsCollectorIdSourceIdRoute
  '/air/case-management/$id': typeof DashboardAirCaseManagementIdIndexRoute
  '/graylog/automation-settings/new': typeof DashboardGraylogAutomationSettingsNewIndexRoute
  '/integrations/collectors/$collectorId': typeof DashboardIntegrationsCollectorsCollectorIdIndexRoute
  '/integrations/collectors/sources/new/$definitionId': typeof DashboardIntegrationsCollectorsSourcesNewDefinitionIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRouteRouteWithChildren
  '/signup': typeof SignupRouteRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_dashboard': typeof DashboardRouteWithChildren
  '/_dashboard/activity': typeof DashboardActivityRouteRouteWithChildren
  '/_dashboard/report': typeof DashboardReportRouteRouteWithChildren
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/logout': typeof AuthLogoutRoute
  '/_auth/new-password-required': typeof AuthNewPasswordRequiredRoute
  '/_auth/setup-totp': typeof AuthSetupTotpRoute
  '/_auth/sso-callback': typeof AuthSsoCallbackRoute
  '/_dashboard/custom-dashboards': typeof DashboardCustomDashboardsRouteWithChildren
  '/_dashboard/graylog': typeof DashboardGraylogRouteWithChildren
  '/_dashboard/home': typeof DashboardHomeRoute
  '/_dashboard/integrations': typeof DashboardIntegrationsRouteWithChildren
  '/_dashboard/mdr': typeof DashboardMdrRouteWithChildren
  '/_dashboard/settings': typeof DashboardSettingsRouteWithChildren
  '/onboarding/setup-totp': typeof OnboardingSetupTotpRoute
  '/signup/invite': typeof SignupInviteRoute
  '/signup/switch-accounts': typeof SignupSwitchAccountsRoute
  '/_dashboard/activity/actions': typeof DashboardActivityActionsRoute
  '/_dashboard/activity/playbooks': typeof DashboardActivityPlaybooksRoute
  '/_dashboard/air/_layout': typeof DashboardAirLayoutRouteWithChildren
  '/_dashboard/custom-dashboards/builder': typeof DashboardCustomDashboardsBuilderRoute
  '/_dashboard/custom-dashboards/library': typeof DashboardCustomDashboardsLibraryRoute
  '/_dashboard/dev/kitchen-sink': typeof DashboardDevKitchenSinkRoute
  '/_dashboard/graylog/alerts': typeof DashboardGraylogAlertsRoute
  '/_dashboard/graylog/triggered-alerts': typeof DashboardGraylogTriggeredAlertsRoute
  '/_dashboard/mdr/executive-reports': typeof DashboardMdrExecutiveReportsRoute
  '/_dashboard/multi-tenant/_layout': typeof DashboardMultiTenantLayoutRouteWithChildren
  '/_dashboard/playbooks/$id': typeof DashboardPlaybooksIdRoute
  '/_dashboard/report/air': typeof DashboardReportAirRoute
  '/_dashboard/report/graylog': typeof DashboardReportGraylogRoute
  '/_dashboard/settings/notifications': typeof DashboardSettingsNotificationsRoute
  '/_dashboard/settings/profile': typeof DashboardSettingsProfileRoute
  '/_dashboard/settings/tenant-settings': typeof DashboardSettingsTenantSettingsRouteWithChildren
  '/signup/azure/callback': typeof SignupAzureCallbackRoute
  '/signup/azure/confirm': typeof SignupAzureConfirmRoute
  '/_dashboard/actions/': typeof DashboardActionsIndexRoute
  '/_dashboard/activity/': typeof DashboardActivityIndexRoute
  '/_dashboard/custom-dashboards/': typeof DashboardCustomDashboardsIndexRoute
  '/_dashboard/graylog/': typeof DashboardGraylogIndexRoute
  '/_dashboard/integrations/': typeof DashboardIntegrationsIndexRoute
  '/_dashboard/mdr/': typeof DashboardMdrIndexRoute
  '/_dashboard/playbooks/': typeof DashboardPlaybooksIndexRoute
  '/_dashboard/search/': typeof DashboardSearchIndexRoute
  '/_dashboard/settings/': typeof DashboardSettingsIndexRoute
  '/_dashboard/unauthorized/': typeof DashboardUnauthorizedIndexRoute
  '/signup/azure/': typeof SignupAzureIndexRoute
  '/_dashboard/air/_layout/automation-settings': typeof DashboardAirLayoutAutomationSettingsRoute
  '/_dashboard/air/_layout/case-management': typeof DashboardAirLayoutCaseManagementRoute
  '/_dashboard/air/_layout/overview': typeof DashboardAirLayoutOverviewRoute
  '/_dashboard/air/_layout/policy-management': typeof DashboardAirLayoutPolicyManagementRoute
  '/_dashboard/air/automation-settings/$mapping_id': typeof DashboardAirAutomationSettingsMapping_idRoute
  '/_dashboard/air/automation-settings/new': typeof DashboardAirAutomationSettingsNewRoute
  '/_dashboard/air/case-management/$id': typeof DashboardAirCaseManagementIdRouteWithChildren
  '/_dashboard/air/policy-management/$policyId': typeof DashboardAirPolicyManagementPolicyIdRoute
  '/_dashboard/air/policy-management/new': typeof DashboardAirPolicyManagementNewRoute
  '/_dashboard/integrations/cloud/$id': typeof DashboardIntegrationsCloudIdRoute
  '/_dashboard/integrations/collectors/new': typeof DashboardIntegrationsCollectorsNewRoute
  '/_dashboard/integrations/new/$id': typeof DashboardIntegrationsNewIdRoute
  '/_dashboard/integrations/new/callback': typeof DashboardIntegrationsNewCallbackRoute
  '/_dashboard/multi-tenant/_layout/automations': typeof DashboardMultiTenantLayoutAutomationsRoute
  '/_dashboard/multi-tenant/_layout/cases': typeof DashboardMultiTenantLayoutCasesRoute
  '/_dashboard/multi-tenant/_layout/policies': typeof DashboardMultiTenantLayoutPoliciesRoute
  '/_dashboard/settings/tenant-settings/api-keys': typeof DashboardSettingsTenantSettingsApiKeysRoute
  '/_dashboard/settings/tenant-settings/authentication': typeof DashboardSettingsTenantSettingsAuthenticationRoute
  '/_dashboard/settings/tenant-settings/invitations': typeof DashboardSettingsTenantSettingsInvitationsRoute
  '/_dashboard/settings/tenant-settings/members': typeof DashboardSettingsTenantSettingsMembersRoute
  '/_dashboard/settings/tenant-settings/notification-recipients': typeof DashboardSettingsTenantSettingsNotificationRecipientsRoute
  '/_dashboard/air/_layout/': typeof DashboardAirLayoutIndexRoute
  '/_dashboard/graylog/automation-settings/': typeof DashboardGraylogAutomationSettingsIndexRoute
  '/_dashboard/graylog/event-definitions/': typeof DashboardGraylogEventDefinitionsIndexRoute
  '/_dashboard/integrations/cloud/': typeof DashboardIntegrationsCloudIndexRoute
  '/_dashboard/integrations/collectors/': typeof DashboardIntegrationsCollectorsIndexRoute
  '/_dashboard/integrations/new/': typeof DashboardIntegrationsNewIndexRoute
  '/_dashboard/multi-tenant/_layout/': typeof DashboardMultiTenantLayoutIndexRoute
  '/_dashboard/air/case-management/$id/automation': typeof DashboardAirCaseManagementIdAutomationRoute
  '/_dashboard/air/case-management/$id/behavior': typeof DashboardAirCaseManagementIdBehaviorRoute
  '/_dashboard/air/case-management/$id/case-details': typeof DashboardAirCaseManagementIdCaseDetailsRoute
  '/_dashboard/air/case-management/$id/discussion': typeof DashboardAirCaseManagementIdDiscussionRoute
  '/_dashboard/air/case-management/$id/evidence': typeof DashboardAirCaseManagementIdEvidenceRoute
  '/_dashboard/air/case-management/$id/investigation-steps': typeof DashboardAirCaseManagementIdInvestigationStepsRoute
  '/_dashboard/air/case-management/$id/logs': typeof DashboardAirCaseManagementIdLogsRoute
  '/_dashboard/air/case-management/$id/overview': typeof DashboardAirCaseManagementIdOverviewRoute
  '/_dashboard/graylog/automation-settings/edit/$id': typeof DashboardGraylogAutomationSettingsEditIdRoute
  '/_dashboard/integrations/collectors/$collectorId/$sourceId': typeof DashboardIntegrationsCollectorsCollectorIdSourceIdRoute
  '/_dashboard/air/case-management/$id/': typeof DashboardAirCaseManagementIdIndexRoute
  '/_dashboard/graylog/automation-settings/new/': typeof DashboardGraylogAutomationSettingsNewIndexRoute
  '/_dashboard/integrations/collectors/$collectorId/': typeof DashboardIntegrationsCollectorsCollectorIdIndexRoute
  '/_dashboard/integrations/collectors/sources/new/$definitionId': typeof DashboardIntegrationsCollectorsSourcesNewDefinitionIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/onboarding'
    | '/signup'
    | '/activity'
    | '/report'
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/new-password-required'
    | '/setup-totp'
    | '/sso-callback'
    | '/custom-dashboards'
    | '/graylog'
    | '/home'
    | '/integrations'
    | '/mdr'
    | '/settings'
    | '/onboarding/setup-totp'
    | '/signup/invite'
    | '/signup/switch-accounts'
    | '/activity/actions'
    | '/activity/playbooks'
    | '/air'
    | '/custom-dashboards/builder'
    | '/custom-dashboards/library'
    | '/dev/kitchen-sink'
    | '/graylog/alerts'
    | '/graylog/triggered-alerts'
    | '/mdr/executive-reports'
    | '/multi-tenant'
    | '/playbooks/$id'
    | '/report/air'
    | '/report/graylog'
    | '/settings/notifications'
    | '/settings/profile'
    | '/settings/tenant-settings'
    | '/signup/azure/callback'
    | '/signup/azure/confirm'
    | '/actions/'
    | '/activity/'
    | '/custom-dashboards/'
    | '/graylog/'
    | '/integrations/'
    | '/mdr/'
    | '/playbooks/'
    | '/search/'
    | '/settings/'
    | '/unauthorized/'
    | '/signup/azure/'
    | '/air/automation-settings'
    | '/air/case-management'
    | '/air/overview'
    | '/air/policy-management'
    | '/air/automation-settings/$mapping_id'
    | '/air/automation-settings/new'
    | '/air/case-management/$id'
    | '/air/policy-management/$policyId'
    | '/air/policy-management/new'
    | '/integrations/cloud/$id'
    | '/integrations/collectors/new'
    | '/integrations/new/$id'
    | '/integrations/new/callback'
    | '/multi-tenant/automations'
    | '/multi-tenant/cases'
    | '/multi-tenant/policies'
    | '/settings/tenant-settings/api-keys'
    | '/settings/tenant-settings/authentication'
    | '/settings/tenant-settings/invitations'
    | '/settings/tenant-settings/members'
    | '/settings/tenant-settings/notification-recipients'
    | '/air/'
    | '/graylog/automation-settings/'
    | '/graylog/event-definitions/'
    | '/integrations/cloud/'
    | '/integrations/collectors/'
    | '/integrations/new/'
    | '/multi-tenant/'
    | '/air/case-management/$id/automation'
    | '/air/case-management/$id/behavior'
    | '/air/case-management/$id/case-details'
    | '/air/case-management/$id/discussion'
    | '/air/case-management/$id/evidence'
    | '/air/case-management/$id/investigation-steps'
    | '/air/case-management/$id/logs'
    | '/air/case-management/$id/overview'
    | '/graylog/automation-settings/edit/$id'
    | '/integrations/collectors/$collectorId/$sourceId'
    | '/air/case-management/$id/'
    | '/graylog/automation-settings/new/'
    | '/integrations/collectors/$collectorId/'
    | '/integrations/collectors/sources/new/$definitionId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/onboarding'
    | '/signup'
    | '/report'
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/new-password-required'
    | '/setup-totp'
    | '/sso-callback'
    | '/home'
    | '/onboarding/setup-totp'
    | '/signup/invite'
    | '/signup/switch-accounts'
    | '/activity/actions'
    | '/activity/playbooks'
    | '/custom-dashboards/builder'
    | '/custom-dashboards/library'
    | '/dev/kitchen-sink'
    | '/graylog/alerts'
    | '/graylog/triggered-alerts'
    | '/mdr/executive-reports'
    | '/playbooks/$id'
    | '/report/air'
    | '/report/graylog'
    | '/settings/notifications'
    | '/settings/profile'
    | '/settings/tenant-settings'
    | '/signup/azure/callback'
    | '/signup/azure/confirm'
    | '/actions'
    | '/activity'
    | '/custom-dashboards'
    | '/graylog'
    | '/integrations'
    | '/mdr'
    | '/playbooks'
    | '/search'
    | '/settings'
    | '/unauthorized'
    | '/signup/azure'
    | '/air/automation-settings'
    | '/air/case-management'
    | '/air/overview'
    | '/air/policy-management'
    | '/air/automation-settings/$mapping_id'
    | '/air/automation-settings/new'
    | '/air/policy-management/$policyId'
    | '/air/policy-management/new'
    | '/integrations/cloud/$id'
    | '/integrations/collectors/new'
    | '/integrations/new/$id'
    | '/integrations/new/callback'
    | '/multi-tenant/automations'
    | '/multi-tenant/cases'
    | '/multi-tenant/policies'
    | '/settings/tenant-settings/api-keys'
    | '/settings/tenant-settings/authentication'
    | '/settings/tenant-settings/invitations'
    | '/settings/tenant-settings/members'
    | '/settings/tenant-settings/notification-recipients'
    | '/air'
    | '/graylog/automation-settings'
    | '/graylog/event-definitions'
    | '/integrations/cloud'
    | '/integrations/collectors'
    | '/integrations/new'
    | '/multi-tenant'
    | '/air/case-management/$id/automation'
    | '/air/case-management/$id/behavior'
    | '/air/case-management/$id/case-details'
    | '/air/case-management/$id/discussion'
    | '/air/case-management/$id/evidence'
    | '/air/case-management/$id/investigation-steps'
    | '/air/case-management/$id/logs'
    | '/air/case-management/$id/overview'
    | '/graylog/automation-settings/edit/$id'
    | '/integrations/collectors/$collectorId/$sourceId'
    | '/air/case-management/$id'
    | '/graylog/automation-settings/new'
    | '/integrations/collectors/$collectorId'
    | '/integrations/collectors/sources/new/$definitionId'
  id:
    | '__root__'
    | '/'
    | '/onboarding'
    | '/signup'
    | '/_auth'
    | '/_dashboard'
    | '/_dashboard/activity'
    | '/_dashboard/report'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/logout'
    | '/_auth/new-password-required'
    | '/_auth/setup-totp'
    | '/_auth/sso-callback'
    | '/_dashboard/custom-dashboards'
    | '/_dashboard/graylog'
    | '/_dashboard/home'
    | '/_dashboard/integrations'
    | '/_dashboard/mdr'
    | '/_dashboard/settings'
    | '/onboarding/setup-totp'
    | '/signup/invite'
    | '/signup/switch-accounts'
    | '/_dashboard/activity/actions'
    | '/_dashboard/activity/playbooks'
    | '/_dashboard/air/_layout'
    | '/_dashboard/custom-dashboards/builder'
    | '/_dashboard/custom-dashboards/library'
    | '/_dashboard/dev/kitchen-sink'
    | '/_dashboard/graylog/alerts'
    | '/_dashboard/graylog/triggered-alerts'
    | '/_dashboard/mdr/executive-reports'
    | '/_dashboard/multi-tenant/_layout'
    | '/_dashboard/playbooks/$id'
    | '/_dashboard/report/air'
    | '/_dashboard/report/graylog'
    | '/_dashboard/settings/notifications'
    | '/_dashboard/settings/profile'
    | '/_dashboard/settings/tenant-settings'
    | '/signup/azure/callback'
    | '/signup/azure/confirm'
    | '/_dashboard/actions/'
    | '/_dashboard/activity/'
    | '/_dashboard/custom-dashboards/'
    | '/_dashboard/graylog/'
    | '/_dashboard/integrations/'
    | '/_dashboard/mdr/'
    | '/_dashboard/playbooks/'
    | '/_dashboard/search/'
    | '/_dashboard/settings/'
    | '/_dashboard/unauthorized/'
    | '/signup/azure/'
    | '/_dashboard/air/_layout/automation-settings'
    | '/_dashboard/air/_layout/case-management'
    | '/_dashboard/air/_layout/overview'
    | '/_dashboard/air/_layout/policy-management'
    | '/_dashboard/air/automation-settings/$mapping_id'
    | '/_dashboard/air/automation-settings/new'
    | '/_dashboard/air/case-management/$id'
    | '/_dashboard/air/policy-management/$policyId'
    | '/_dashboard/air/policy-management/new'
    | '/_dashboard/integrations/cloud/$id'
    | '/_dashboard/integrations/collectors/new'
    | '/_dashboard/integrations/new/$id'
    | '/_dashboard/integrations/new/callback'
    | '/_dashboard/multi-tenant/_layout/automations'
    | '/_dashboard/multi-tenant/_layout/cases'
    | '/_dashboard/multi-tenant/_layout/policies'
    | '/_dashboard/settings/tenant-settings/api-keys'
    | '/_dashboard/settings/tenant-settings/authentication'
    | '/_dashboard/settings/tenant-settings/invitations'
    | '/_dashboard/settings/tenant-settings/members'
    | '/_dashboard/settings/tenant-settings/notification-recipients'
    | '/_dashboard/air/_layout/'
    | '/_dashboard/graylog/automation-settings/'
    | '/_dashboard/graylog/event-definitions/'
    | '/_dashboard/integrations/cloud/'
    | '/_dashboard/integrations/collectors/'
    | '/_dashboard/integrations/new/'
    | '/_dashboard/multi-tenant/_layout/'
    | '/_dashboard/air/case-management/$id/automation'
    | '/_dashboard/air/case-management/$id/behavior'
    | '/_dashboard/air/case-management/$id/case-details'
    | '/_dashboard/air/case-management/$id/discussion'
    | '/_dashboard/air/case-management/$id/evidence'
    | '/_dashboard/air/case-management/$id/investigation-steps'
    | '/_dashboard/air/case-management/$id/logs'
    | '/_dashboard/air/case-management/$id/overview'
    | '/_dashboard/graylog/automation-settings/edit/$id'
    | '/_dashboard/integrations/collectors/$collectorId/$sourceId'
    | '/_dashboard/air/case-management/$id/'
    | '/_dashboard/graylog/automation-settings/new/'
    | '/_dashboard/integrations/collectors/$collectorId/'
    | '/_dashboard/integrations/collectors/sources/new/$definitionId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  OnboardingRouteRoute: typeof OnboardingRouteRouteWithChildren
  SignupRouteRoute: typeof SignupRouteRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  DashboardRoute: typeof DashboardRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/logout': {
      id: '/_auth/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof AuthLogoutRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/new-password-required': {
      id: '/_auth/new-password-required'
      path: '/new-password-required'
      fullPath: '/new-password-required'
      preLoaderRoute: typeof AuthNewPasswordRequiredRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/setup-totp': {
      id: '/_auth/setup-totp'
      path: '/setup-totp'
      fullPath: '/setup-totp'
      preLoaderRoute: typeof AuthSetupTotpRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sso-callback': {
      id: '/_auth/sso-callback'
      path: '/sso-callback'
      fullPath: '/sso-callback'
      preLoaderRoute: typeof AuthSsoCallbackRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_dashboard/activity': {
      id: '/_dashboard/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof DashboardActivityRouteRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/custom-dashboards': {
      id: '/_dashboard/custom-dashboards'
      path: '/custom-dashboards'
      fullPath: '/custom-dashboards'
      preLoaderRoute: typeof DashboardCustomDashboardsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/graylog': {
      id: '/_dashboard/graylog'
      path: '/graylog'
      fullPath: '/graylog'
      preLoaderRoute: typeof DashboardGraylogRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/home': {
      id: '/_dashboard/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof DashboardHomeRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/integrations': {
      id: '/_dashboard/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof DashboardIntegrationsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/mdr': {
      id: '/_dashboard/mdr'
      path: '/mdr'
      fullPath: '/mdr'
      preLoaderRoute: typeof DashboardMdrRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/report': {
      id: '/_dashboard/report'
      path: '/report'
      fullPath: '/report'
      preLoaderRoute: typeof DashboardReportRouteRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/settings': {
      id: '/_dashboard/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof DashboardSettingsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/onboarding/setup-totp': {
      id: '/onboarding/setup-totp'
      path: '/setup-totp'
      fullPath: '/onboarding/setup-totp'
      preLoaderRoute: typeof OnboardingSetupTotpRouteImport
      parentRoute: typeof OnboardingRouteRoute
    }
    '/signup/invite': {
      id: '/signup/invite'
      path: '/invite'
      fullPath: '/signup/invite'
      preLoaderRoute: typeof SignupInviteRouteImport
      parentRoute: typeof SignupRouteRoute
    }
    '/signup/switch-accounts': {
      id: '/signup/switch-accounts'
      path: '/switch-accounts'
      fullPath: '/signup/switch-accounts'
      preLoaderRoute: typeof SignupSwitchAccountsRouteImport
      parentRoute: typeof SignupRouteRoute
    }
    '/_dashboard/actions/': {
      id: '/_dashboard/actions/'
      path: '/actions'
      fullPath: '/actions/'
      preLoaderRoute: typeof DashboardActionsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/activity/': {
      id: '/_dashboard/activity/'
      path: '/'
      fullPath: '/activity/'
      preLoaderRoute: typeof DashboardActivityIndexRouteImport
      parentRoute: typeof DashboardActivityRouteRoute
    }
    '/_dashboard/activity/actions': {
      id: '/_dashboard/activity/actions'
      path: '/actions'
      fullPath: '/activity/actions'
      preLoaderRoute: typeof DashboardActivityActionsRouteImport
      parentRoute: typeof DashboardActivityRouteRoute
    }
    '/_dashboard/activity/playbooks': {
      id: '/_dashboard/activity/playbooks'
      path: '/playbooks'
      fullPath: '/activity/playbooks'
      preLoaderRoute: typeof DashboardActivityPlaybooksRouteImport
      parentRoute: typeof DashboardActivityRouteRoute
    }
    '/_dashboard/air/_layout': {
      id: '/_dashboard/air/_layout'
      path: '/air'
      fullPath: '/air'
      preLoaderRoute: typeof DashboardAirLayoutRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/custom-dashboards/': {
      id: '/_dashboard/custom-dashboards/'
      path: '/'
      fullPath: '/custom-dashboards/'
      preLoaderRoute: typeof DashboardCustomDashboardsIndexRouteImport
      parentRoute: typeof DashboardCustomDashboardsRoute
    }
    '/_dashboard/custom-dashboards/builder': {
      id: '/_dashboard/custom-dashboards/builder'
      path: '/builder'
      fullPath: '/custom-dashboards/builder'
      preLoaderRoute: typeof DashboardCustomDashboardsBuilderRouteImport
      parentRoute: typeof DashboardCustomDashboardsRoute
    }
    '/_dashboard/custom-dashboards/library': {
      id: '/_dashboard/custom-dashboards/library'
      path: '/library'
      fullPath: '/custom-dashboards/library'
      preLoaderRoute: typeof DashboardCustomDashboardsLibraryRouteImport
      parentRoute: typeof DashboardCustomDashboardsRoute
    }
    '/_dashboard/dev/kitchen-sink': {
      id: '/_dashboard/dev/kitchen-sink'
      path: '/dev/kitchen-sink'
      fullPath: '/dev/kitchen-sink'
      preLoaderRoute: typeof DashboardDevKitchenSinkRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/graylog/': {
      id: '/_dashboard/graylog/'
      path: '/'
      fullPath: '/graylog/'
      preLoaderRoute: typeof DashboardGraylogIndexRouteImport
      parentRoute: typeof DashboardGraylogRoute
    }
    '/_dashboard/graylog/alerts': {
      id: '/_dashboard/graylog/alerts'
      path: '/alerts'
      fullPath: '/graylog/alerts'
      preLoaderRoute: typeof DashboardGraylogAlertsRouteImport
      parentRoute: typeof DashboardGraylogRoute
    }
    '/_dashboard/graylog/triggered-alerts': {
      id: '/_dashboard/graylog/triggered-alerts'
      path: '/triggered-alerts'
      fullPath: '/graylog/triggered-alerts'
      preLoaderRoute: typeof DashboardGraylogTriggeredAlertsRouteImport
      parentRoute: typeof DashboardGraylogRoute
    }
    '/_dashboard/integrations/': {
      id: '/_dashboard/integrations/'
      path: '/'
      fullPath: '/integrations/'
      preLoaderRoute: typeof DashboardIntegrationsIndexRouteImport
      parentRoute: typeof DashboardIntegrationsRoute
    }
    '/_dashboard/mdr/': {
      id: '/_dashboard/mdr/'
      path: '/'
      fullPath: '/mdr/'
      preLoaderRoute: typeof DashboardMdrIndexRouteImport
      parentRoute: typeof DashboardMdrRoute
    }
    '/_dashboard/mdr/executive-reports': {
      id: '/_dashboard/mdr/executive-reports'
      path: '/executive-reports'
      fullPath: '/mdr/executive-reports'
      preLoaderRoute: typeof DashboardMdrExecutiveReportsRouteImport
      parentRoute: typeof DashboardMdrRoute
    }
    '/_dashboard/multi-tenant/_layout': {
      id: '/_dashboard/multi-tenant/_layout'
      path: '/multi-tenant'
      fullPath: '/multi-tenant'
      preLoaderRoute: typeof DashboardMultiTenantLayoutRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/playbooks/': {
      id: '/_dashboard/playbooks/'
      path: '/playbooks'
      fullPath: '/playbooks/'
      preLoaderRoute: typeof DashboardPlaybooksIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/playbooks/$id': {
      id: '/_dashboard/playbooks/$id'
      path: '/playbooks/$id'
      fullPath: '/playbooks/$id'
      preLoaderRoute: typeof DashboardPlaybooksIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/report/air': {
      id: '/_dashboard/report/air'
      path: '/air'
      fullPath: '/report/air'
      preLoaderRoute: typeof DashboardReportAirRouteImport
      parentRoute: typeof DashboardReportRouteRoute
    }
    '/_dashboard/report/graylog': {
      id: '/_dashboard/report/graylog'
      path: '/graylog'
      fullPath: '/report/graylog'
      preLoaderRoute: typeof DashboardReportGraylogRouteImport
      parentRoute: typeof DashboardReportRouteRoute
    }
    '/_dashboard/search/': {
      id: '/_dashboard/search/'
      path: '/search'
      fullPath: '/search/'
      preLoaderRoute: typeof DashboardSearchIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/settings/': {
      id: '/_dashboard/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof DashboardSettingsIndexRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/_dashboard/settings/notifications': {
      id: '/_dashboard/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof DashboardSettingsNotificationsRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/_dashboard/settings/profile': {
      id: '/_dashboard/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof DashboardSettingsProfileRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/_dashboard/settings/tenant-settings': {
      id: '/_dashboard/settings/tenant-settings'
      path: '/tenant-settings'
      fullPath: '/settings/tenant-settings'
      preLoaderRoute: typeof DashboardSettingsTenantSettingsRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/_dashboard/unauthorized/': {
      id: '/_dashboard/unauthorized/'
      path: '/unauthorized'
      fullPath: '/unauthorized/'
      preLoaderRoute: typeof DashboardUnauthorizedIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/signup/azure/': {
      id: '/signup/azure/'
      path: '/azure'
      fullPath: '/signup/azure/'
      preLoaderRoute: typeof SignupAzureIndexRouteImport
      parentRoute: typeof SignupRouteRoute
    }
    '/signup/azure/callback': {
      id: '/signup/azure/callback'
      path: '/azure/callback'
      fullPath: '/signup/azure/callback'
      preLoaderRoute: typeof SignupAzureCallbackRouteImport
      parentRoute: typeof SignupRouteRoute
    }
    '/signup/azure/confirm': {
      id: '/signup/azure/confirm'
      path: '/azure/confirm'
      fullPath: '/signup/azure/confirm'
      preLoaderRoute: typeof SignupAzureConfirmRouteImport
      parentRoute: typeof SignupRouteRoute
    }
    '/_dashboard/air/_layout/': {
      id: '/_dashboard/air/_layout/'
      path: '/'
      fullPath: '/air/'
      preLoaderRoute: typeof DashboardAirLayoutIndexRouteImport
      parentRoute: typeof DashboardAirLayoutRoute
    }
    '/_dashboard/air/_layout/automation-settings': {
      id: '/_dashboard/air/_layout/automation-settings'
      path: '/automation-settings'
      fullPath: '/air/automation-settings'
      preLoaderRoute: typeof DashboardAirLayoutAutomationSettingsRouteImport
      parentRoute: typeof DashboardAirLayoutRoute
    }
    '/_dashboard/air/_layout/case-management': {
      id: '/_dashboard/air/_layout/case-management'
      path: '/case-management'
      fullPath: '/air/case-management'
      preLoaderRoute: typeof DashboardAirLayoutCaseManagementRouteImport
      parentRoute: typeof DashboardAirLayoutRoute
    }
    '/_dashboard/air/_layout/overview': {
      id: '/_dashboard/air/_layout/overview'
      path: '/overview'
      fullPath: '/air/overview'
      preLoaderRoute: typeof DashboardAirLayoutOverviewRouteImport
      parentRoute: typeof DashboardAirLayoutRoute
    }
    '/_dashboard/air/_layout/policy-management': {
      id: '/_dashboard/air/_layout/policy-management'
      path: '/policy-management'
      fullPath: '/air/policy-management'
      preLoaderRoute: typeof DashboardAirLayoutPolicyManagementRouteImport
      parentRoute: typeof DashboardAirLayoutRoute
    }
    '/_dashboard/air/automation-settings/$mapping_id': {
      id: '/_dashboard/air/automation-settings/$mapping_id'
      path: '/air/automation-settings/$mapping_id'
      fullPath: '/air/automation-settings/$mapping_id'
      preLoaderRoute: typeof DashboardAirAutomationSettingsMapping_idRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/air/automation-settings/new': {
      id: '/_dashboard/air/automation-settings/new'
      path: '/air/automation-settings/new'
      fullPath: '/air/automation-settings/new'
      preLoaderRoute: typeof DashboardAirAutomationSettingsNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/air/case-management/$id': {
      id: '/_dashboard/air/case-management/$id'
      path: '/air/case-management/$id'
      fullPath: '/air/case-management/$id'
      preLoaderRoute: typeof DashboardAirCaseManagementIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/air/policy-management/$policyId': {
      id: '/_dashboard/air/policy-management/$policyId'
      path: '/air/policy-management/$policyId'
      fullPath: '/air/policy-management/$policyId'
      preLoaderRoute: typeof DashboardAirPolicyManagementPolicyIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/air/policy-management/new': {
      id: '/_dashboard/air/policy-management/new'
      path: '/air/policy-management/new'
      fullPath: '/air/policy-management/new'
      preLoaderRoute: typeof DashboardAirPolicyManagementNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/_dashboard/graylog/automation-settings/': {
      id: '/_dashboard/graylog/automation-settings/'
      path: '/automation-settings'
      fullPath: '/graylog/automation-settings/'
      preLoaderRoute: typeof DashboardGraylogAutomationSettingsIndexRouteImport
      parentRoute: typeof DashboardGraylogRoute
    }
    '/_dashboard/graylog/event-definitions/': {
      id: '/_dashboard/graylog/event-definitions/'
      path: '/event-definitions'
      fullPath: '/graylog/event-definitions/'
      preLoaderRoute: typeof DashboardGraylogEventDefinitionsIndexRouteImport
      parentRoute: typeof DashboardGraylogRoute
    }
    '/_dashboard/integrations/cloud/': {
      id: '/_dashboard/integrations/cloud/'
      path: '/cloud'
      fullPath: '/integrations/cloud/'
      preLoaderRoute: typeof DashboardIntegrationsCloudIndexRouteImport
      parentRoute: typeof DashboardIntegrationsRoute
    }
    '/_dashboard/integrations/cloud/$id': {
      id: '/_dashboard/integrations/cloud/$id'
      path: '/cloud/$id'
      fullPath: '/integrations/cloud/$id'
      preLoaderRoute: typeof DashboardIntegrationsCloudIdRouteImport
      parentRoute: typeof DashboardIntegrationsRoute
    }
    '/_dashboard/integrations/collectors/': {
      id: '/_dashboard/integrations/collectors/'
      path: '/collectors'
      fullPath: '/integrations/collectors/'
      preLoaderRoute: typeof DashboardIntegrationsCollectorsIndexRouteImport
      parentRoute: typeof DashboardIntegrationsRoute
    }
    '/_dashboard/integrations/collectors/new': {
      id: '/_dashboard/integrations/collectors/new'
      path: '/collectors/new'
      fullPath: '/integrations/collectors/new'
      preLoaderRoute: typeof DashboardIntegrationsCollectorsNewRouteImport
      parentRoute: typeof DashboardIntegrationsRoute
    }
    '/_dashboard/integrations/new/': {
      id: '/_dashboard/integrations/new/'
      path: '/new'
      fullPath: '/integrations/new/'
      preLoaderRoute: typeof DashboardIntegrationsNewIndexRouteImport
      parentRoute: typeof DashboardIntegrationsRoute
    }
    '/_dashboard/integrations/new/$id': {
      id: '/_dashboard/integrations/new/$id'
      path: '/new/$id'
      fullPath: '/integrations/new/$id'
      preLoaderRoute: typeof DashboardIntegrationsNewIdRouteImport
      parentRoute: typeof DashboardIntegrationsRoute
    }
    '/_dashboard/integrations/new/callback': {
      id: '/_dashboard/integrations/new/callback'
      path: '/new/callback'
      fullPath: '/integrations/new/callback'
      preLoaderRoute: typeof DashboardIntegrationsNewCallbackRouteImport
      parentRoute: typeof DashboardIntegrationsRoute
    }
    '/_dashboard/multi-tenant/_layout/': {
      id: '/_dashboard/multi-tenant/_layout/'
      path: '/'
      fullPath: '/multi-tenant/'
      preLoaderRoute: typeof DashboardMultiTenantLayoutIndexRouteImport
      parentRoute: typeof DashboardMultiTenantLayoutRoute
    }
    '/_dashboard/multi-tenant/_layout/automations': {
      id: '/_dashboard/multi-tenant/_layout/automations'
      path: '/automations'
      fullPath: '/multi-tenant/automations'
      preLoaderRoute: typeof DashboardMultiTenantLayoutAutomationsRouteImport
      parentRoute: typeof DashboardMultiTenantLayoutRoute
    }
    '/_dashboard/multi-tenant/_layout/cases': {
      id: '/_dashboard/multi-tenant/_layout/cases'
      path: '/cases'
      fullPath: '/multi-tenant/cases'
      preLoaderRoute: typeof DashboardMultiTenantLayoutCasesRouteImport
      parentRoute: typeof DashboardMultiTenantLayoutRoute
    }
    '/_dashboard/multi-tenant/_layout/policies': {
      id: '/_dashboard/multi-tenant/_layout/policies'
      path: '/policies'
      fullPath: '/multi-tenant/policies'
      preLoaderRoute: typeof DashboardMultiTenantLayoutPoliciesRouteImport
      parentRoute: typeof DashboardMultiTenantLayoutRoute
    }
    '/_dashboard/settings/tenant-settings/api-keys': {
      id: '/_dashboard/settings/tenant-settings/api-keys'
      path: '/api-keys'
      fullPath: '/settings/tenant-settings/api-keys'
      preLoaderRoute: typeof DashboardSettingsTenantSettingsApiKeysRouteImport
      parentRoute: typeof DashboardSettingsTenantSettingsRoute
    }
    '/_dashboard/settings/tenant-settings/authentication': {
      id: '/_dashboard/settings/tenant-settings/authentication'
      path: '/authentication'
      fullPath: '/settings/tenant-settings/authentication'
      preLoaderRoute: typeof DashboardSettingsTenantSettingsAuthenticationRouteImport
      parentRoute: typeof DashboardSettingsTenantSettingsRoute
    }
    '/_dashboard/settings/tenant-settings/invitations': {
      id: '/_dashboard/settings/tenant-settings/invitations'
      path: '/invitations'
      fullPath: '/settings/tenant-settings/invitations'
      preLoaderRoute: typeof DashboardSettingsTenantSettingsInvitationsRouteImport
      parentRoute: typeof DashboardSettingsTenantSettingsRoute
    }
    '/_dashboard/settings/tenant-settings/members': {
      id: '/_dashboard/settings/tenant-settings/members'
      path: '/members'
      fullPath: '/settings/tenant-settings/members'
      preLoaderRoute: typeof DashboardSettingsTenantSettingsMembersRouteImport
      parentRoute: typeof DashboardSettingsTenantSettingsRoute
    }
    '/_dashboard/settings/tenant-settings/notification-recipients': {
      id: '/_dashboard/settings/tenant-settings/notification-recipients'
      path: '/notification-recipients'
      fullPath: '/settings/tenant-settings/notification-recipients'
      preLoaderRoute: typeof DashboardSettingsTenantSettingsNotificationRecipientsRouteImport
      parentRoute: typeof DashboardSettingsTenantSettingsRoute
    }
    '/_dashboard/air/case-management/$id/': {
      id: '/_dashboard/air/case-management/$id/'
      path: '/'
      fullPath: '/air/case-management/$id/'
      preLoaderRoute: typeof DashboardAirCaseManagementIdIndexRouteImport
      parentRoute: typeof DashboardAirCaseManagementIdRoute
    }
    '/_dashboard/air/case-management/$id/automation': {
      id: '/_dashboard/air/case-management/$id/automation'
      path: '/automation'
      fullPath: '/air/case-management/$id/automation'
      preLoaderRoute: typeof DashboardAirCaseManagementIdAutomationRouteImport
      parentRoute: typeof DashboardAirCaseManagementIdRoute
    }
    '/_dashboard/air/case-management/$id/behavior': {
      id: '/_dashboard/air/case-management/$id/behavior'
      path: '/behavior'
      fullPath: '/air/case-management/$id/behavior'
      preLoaderRoute: typeof DashboardAirCaseManagementIdBehaviorRouteImport
      parentRoute: typeof DashboardAirCaseManagementIdRoute
    }
    '/_dashboard/air/case-management/$id/case-details': {
      id: '/_dashboard/air/case-management/$id/case-details'
      path: '/case-details'
      fullPath: '/air/case-management/$id/case-details'
      preLoaderRoute: typeof DashboardAirCaseManagementIdCaseDetailsRouteImport
      parentRoute: typeof DashboardAirCaseManagementIdRoute
    }
    '/_dashboard/air/case-management/$id/discussion': {
      id: '/_dashboard/air/case-management/$id/discussion'
      path: '/discussion'
      fullPath: '/air/case-management/$id/discussion'
      preLoaderRoute: typeof DashboardAirCaseManagementIdDiscussionRouteImport
      parentRoute: typeof DashboardAirCaseManagementIdRoute
    }
    '/_dashboard/air/case-management/$id/evidence': {
      id: '/_dashboard/air/case-management/$id/evidence'
      path: '/evidence'
      fullPath: '/air/case-management/$id/evidence'
      preLoaderRoute: typeof DashboardAirCaseManagementIdEvidenceRouteImport
      parentRoute: typeof DashboardAirCaseManagementIdRoute
    }
    '/_dashboard/air/case-management/$id/investigation-steps': {
      id: '/_dashboard/air/case-management/$id/investigation-steps'
      path: '/investigation-steps'
      fullPath: '/air/case-management/$id/investigation-steps'
      preLoaderRoute: typeof DashboardAirCaseManagementIdInvestigationStepsRouteImport
      parentRoute: typeof DashboardAirCaseManagementIdRoute
    }
    '/_dashboard/air/case-management/$id/logs': {
      id: '/_dashboard/air/case-management/$id/logs'
      path: '/logs'
      fullPath: '/air/case-management/$id/logs'
      preLoaderRoute: typeof DashboardAirCaseManagementIdLogsRouteImport
      parentRoute: typeof DashboardAirCaseManagementIdRoute
    }
    '/_dashboard/air/case-management/$id/overview': {
      id: '/_dashboard/air/case-management/$id/overview'
      path: '/overview'
      fullPath: '/air/case-management/$id/overview'
      preLoaderRoute: typeof DashboardAirCaseManagementIdOverviewRouteImport
      parentRoute: typeof DashboardAirCaseManagementIdRoute
    }
    '/_dashboard/graylog/automation-settings/edit/$id': {
      id: '/_dashboard/graylog/automation-settings/edit/$id'
      path: '/automation-settings/edit/$id'
      fullPath: '/graylog/automation-settings/edit/$id'
      preLoaderRoute: typeof DashboardGraylogAutomationSettingsEditIdRouteImport
      parentRoute: typeof DashboardGraylogRoute
    }
    '/_dashboard/graylog/automation-settings/new/': {
      id: '/_dashboard/graylog/automation-settings/new/'
      path: '/automation-settings/new'
      fullPath: '/graylog/automation-settings/new/'
      preLoaderRoute: typeof DashboardGraylogAutomationSettingsNewIndexRouteImport
      parentRoute: typeof DashboardGraylogRoute
    }
    '/_dashboard/integrations/collectors/$collectorId/': {
      id: '/_dashboard/integrations/collectors/$collectorId/'
      path: '/collectors/$collectorId'
      fullPath: '/integrations/collectors/$collectorId/'
      preLoaderRoute: typeof DashboardIntegrationsCollectorsCollectorIdIndexRouteImport
      parentRoute: typeof DashboardIntegrationsRoute
    }
    '/_dashboard/integrations/collectors/$collectorId/$sourceId': {
      id: '/_dashboard/integrations/collectors/$collectorId/$sourceId'
      path: '/collectors/$collectorId/$sourceId'
      fullPath: '/integrations/collectors/$collectorId/$sourceId'
      preLoaderRoute: typeof DashboardIntegrationsCollectorsCollectorIdSourceIdRouteImport
      parentRoute: typeof DashboardIntegrationsRoute
    }
    '/_dashboard/integrations/collectors/sources/new/$definitionId': {
      id: '/_dashboard/integrations/collectors/sources/new/$definitionId'
      path: '/collectors/sources/new/$definitionId'
      fullPath: '/integrations/collectors/sources/new/$definitionId'
      preLoaderRoute: typeof DashboardIntegrationsCollectorsSourcesNewDefinitionIdRouteImport
      parentRoute: typeof DashboardIntegrationsRoute
    }
  }
}

interface OnboardingRouteRouteChildren {
  OnboardingSetupTotpRoute: typeof OnboardingSetupTotpRoute
}

const OnboardingRouteRouteChildren: OnboardingRouteRouteChildren = {
  OnboardingSetupTotpRoute: OnboardingSetupTotpRoute,
}

const OnboardingRouteRouteWithChildren = OnboardingRouteRoute._addFileChildren(
  OnboardingRouteRouteChildren,
)

interface SignupRouteRouteChildren {
  SignupInviteRoute: typeof SignupInviteRoute
  SignupSwitchAccountsRoute: typeof SignupSwitchAccountsRoute
  SignupAzureCallbackRoute: typeof SignupAzureCallbackRoute
  SignupAzureConfirmRoute: typeof SignupAzureConfirmRoute
  SignupAzureIndexRoute: typeof SignupAzureIndexRoute
}

const SignupRouteRouteChildren: SignupRouteRouteChildren = {
  SignupInviteRoute: SignupInviteRoute,
  SignupSwitchAccountsRoute: SignupSwitchAccountsRoute,
  SignupAzureCallbackRoute: SignupAzureCallbackRoute,
  SignupAzureConfirmRoute: SignupAzureConfirmRoute,
  SignupAzureIndexRoute: SignupAzureIndexRoute,
}

const SignupRouteRouteWithChildren = SignupRouteRoute._addFileChildren(
  SignupRouteRouteChildren,
)

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthLogoutRoute: typeof AuthLogoutRoute
  AuthNewPasswordRequiredRoute: typeof AuthNewPasswordRequiredRoute
  AuthSetupTotpRoute: typeof AuthSetupTotpRoute
  AuthSsoCallbackRoute: typeof AuthSsoCallbackRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthLogoutRoute: AuthLogoutRoute,
  AuthNewPasswordRequiredRoute: AuthNewPasswordRequiredRoute,
  AuthSetupTotpRoute: AuthSetupTotpRoute,
  AuthSsoCallbackRoute: AuthSsoCallbackRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface DashboardActivityRouteRouteChildren {
  DashboardActivityActionsRoute: typeof DashboardActivityActionsRoute
  DashboardActivityPlaybooksRoute: typeof DashboardActivityPlaybooksRoute
  DashboardActivityIndexRoute: typeof DashboardActivityIndexRoute
}

const DashboardActivityRouteRouteChildren: DashboardActivityRouteRouteChildren =
  {
    DashboardActivityActionsRoute: DashboardActivityActionsRoute,
    DashboardActivityPlaybooksRoute: DashboardActivityPlaybooksRoute,
    DashboardActivityIndexRoute: DashboardActivityIndexRoute,
  }

const DashboardActivityRouteRouteWithChildren =
  DashboardActivityRouteRoute._addFileChildren(
    DashboardActivityRouteRouteChildren,
  )

interface DashboardReportRouteRouteChildren {
  DashboardReportAirRoute: typeof DashboardReportAirRoute
  DashboardReportGraylogRoute: typeof DashboardReportGraylogRoute
}

const DashboardReportRouteRouteChildren: DashboardReportRouteRouteChildren = {
  DashboardReportAirRoute: DashboardReportAirRoute,
  DashboardReportGraylogRoute: DashboardReportGraylogRoute,
}

const DashboardReportRouteRouteWithChildren =
  DashboardReportRouteRoute._addFileChildren(DashboardReportRouteRouteChildren)

interface DashboardCustomDashboardsRouteChildren {
  DashboardCustomDashboardsBuilderRoute: typeof DashboardCustomDashboardsBuilderRoute
  DashboardCustomDashboardsLibraryRoute: typeof DashboardCustomDashboardsLibraryRoute
  DashboardCustomDashboardsIndexRoute: typeof DashboardCustomDashboardsIndexRoute
}

const DashboardCustomDashboardsRouteChildren: DashboardCustomDashboardsRouteChildren =
  {
    DashboardCustomDashboardsBuilderRoute:
      DashboardCustomDashboardsBuilderRoute,
    DashboardCustomDashboardsLibraryRoute:
      DashboardCustomDashboardsLibraryRoute,
    DashboardCustomDashboardsIndexRoute: DashboardCustomDashboardsIndexRoute,
  }

const DashboardCustomDashboardsRouteWithChildren =
  DashboardCustomDashboardsRoute._addFileChildren(
    DashboardCustomDashboardsRouteChildren,
  )

interface DashboardGraylogRouteChildren {
  DashboardGraylogAlertsRoute: typeof DashboardGraylogAlertsRoute
  DashboardGraylogTriggeredAlertsRoute: typeof DashboardGraylogTriggeredAlertsRoute
  DashboardGraylogIndexRoute: typeof DashboardGraylogIndexRoute
  DashboardGraylogAutomationSettingsIndexRoute: typeof DashboardGraylogAutomationSettingsIndexRoute
  DashboardGraylogEventDefinitionsIndexRoute: typeof DashboardGraylogEventDefinitionsIndexRoute
  DashboardGraylogAutomationSettingsEditIdRoute: typeof DashboardGraylogAutomationSettingsEditIdRoute
  DashboardGraylogAutomationSettingsNewIndexRoute: typeof DashboardGraylogAutomationSettingsNewIndexRoute
}

const DashboardGraylogRouteChildren: DashboardGraylogRouteChildren = {
  DashboardGraylogAlertsRoute: DashboardGraylogAlertsRoute,
  DashboardGraylogTriggeredAlertsRoute: DashboardGraylogTriggeredAlertsRoute,
  DashboardGraylogIndexRoute: DashboardGraylogIndexRoute,
  DashboardGraylogAutomationSettingsIndexRoute:
    DashboardGraylogAutomationSettingsIndexRoute,
  DashboardGraylogEventDefinitionsIndexRoute:
    DashboardGraylogEventDefinitionsIndexRoute,
  DashboardGraylogAutomationSettingsEditIdRoute:
    DashboardGraylogAutomationSettingsEditIdRoute,
  DashboardGraylogAutomationSettingsNewIndexRoute:
    DashboardGraylogAutomationSettingsNewIndexRoute,
}

const DashboardGraylogRouteWithChildren =
  DashboardGraylogRoute._addFileChildren(DashboardGraylogRouteChildren)

interface DashboardIntegrationsRouteChildren {
  DashboardIntegrationsIndexRoute: typeof DashboardIntegrationsIndexRoute
  DashboardIntegrationsCloudIdRoute: typeof DashboardIntegrationsCloudIdRoute
  DashboardIntegrationsCollectorsNewRoute: typeof DashboardIntegrationsCollectorsNewRoute
  DashboardIntegrationsNewIdRoute: typeof DashboardIntegrationsNewIdRoute
  DashboardIntegrationsNewCallbackRoute: typeof DashboardIntegrationsNewCallbackRoute
  DashboardIntegrationsCloudIndexRoute: typeof DashboardIntegrationsCloudIndexRoute
  DashboardIntegrationsCollectorsIndexRoute: typeof DashboardIntegrationsCollectorsIndexRoute
  DashboardIntegrationsNewIndexRoute: typeof DashboardIntegrationsNewIndexRoute
  DashboardIntegrationsCollectorsCollectorIdSourceIdRoute: typeof DashboardIntegrationsCollectorsCollectorIdSourceIdRoute
  DashboardIntegrationsCollectorsCollectorIdIndexRoute: typeof DashboardIntegrationsCollectorsCollectorIdIndexRoute
  DashboardIntegrationsCollectorsSourcesNewDefinitionIdRoute: typeof DashboardIntegrationsCollectorsSourcesNewDefinitionIdRoute
}

const DashboardIntegrationsRouteChildren: DashboardIntegrationsRouteChildren = {
  DashboardIntegrationsIndexRoute: DashboardIntegrationsIndexRoute,
  DashboardIntegrationsCloudIdRoute: DashboardIntegrationsCloudIdRoute,
  DashboardIntegrationsCollectorsNewRoute:
    DashboardIntegrationsCollectorsNewRoute,
  DashboardIntegrationsNewIdRoute: DashboardIntegrationsNewIdRoute,
  DashboardIntegrationsNewCallbackRoute: DashboardIntegrationsNewCallbackRoute,
  DashboardIntegrationsCloudIndexRoute: DashboardIntegrationsCloudIndexRoute,
  DashboardIntegrationsCollectorsIndexRoute:
    DashboardIntegrationsCollectorsIndexRoute,
  DashboardIntegrationsNewIndexRoute: DashboardIntegrationsNewIndexRoute,
  DashboardIntegrationsCollectorsCollectorIdSourceIdRoute:
    DashboardIntegrationsCollectorsCollectorIdSourceIdRoute,
  DashboardIntegrationsCollectorsCollectorIdIndexRoute:
    DashboardIntegrationsCollectorsCollectorIdIndexRoute,
  DashboardIntegrationsCollectorsSourcesNewDefinitionIdRoute:
    DashboardIntegrationsCollectorsSourcesNewDefinitionIdRoute,
}

const DashboardIntegrationsRouteWithChildren =
  DashboardIntegrationsRoute._addFileChildren(
    DashboardIntegrationsRouteChildren,
  )

interface DashboardMdrRouteChildren {
  DashboardMdrExecutiveReportsRoute: typeof DashboardMdrExecutiveReportsRoute
  DashboardMdrIndexRoute: typeof DashboardMdrIndexRoute
}

const DashboardMdrRouteChildren: DashboardMdrRouteChildren = {
  DashboardMdrExecutiveReportsRoute: DashboardMdrExecutiveReportsRoute,
  DashboardMdrIndexRoute: DashboardMdrIndexRoute,
}

const DashboardMdrRouteWithChildren = DashboardMdrRoute._addFileChildren(
  DashboardMdrRouteChildren,
)

interface DashboardSettingsTenantSettingsRouteChildren {
  DashboardSettingsTenantSettingsApiKeysRoute: typeof DashboardSettingsTenantSettingsApiKeysRoute
  DashboardSettingsTenantSettingsAuthenticationRoute: typeof DashboardSettingsTenantSettingsAuthenticationRoute
  DashboardSettingsTenantSettingsInvitationsRoute: typeof DashboardSettingsTenantSettingsInvitationsRoute
  DashboardSettingsTenantSettingsMembersRoute: typeof DashboardSettingsTenantSettingsMembersRoute
  DashboardSettingsTenantSettingsNotificationRecipientsRoute: typeof DashboardSettingsTenantSettingsNotificationRecipientsRoute
}

const DashboardSettingsTenantSettingsRouteChildren: DashboardSettingsTenantSettingsRouteChildren =
  {
    DashboardSettingsTenantSettingsApiKeysRoute:
      DashboardSettingsTenantSettingsApiKeysRoute,
    DashboardSettingsTenantSettingsAuthenticationRoute:
      DashboardSettingsTenantSettingsAuthenticationRoute,
    DashboardSettingsTenantSettingsInvitationsRoute:
      DashboardSettingsTenantSettingsInvitationsRoute,
    DashboardSettingsTenantSettingsMembersRoute:
      DashboardSettingsTenantSettingsMembersRoute,
    DashboardSettingsTenantSettingsNotificationRecipientsRoute:
      DashboardSettingsTenantSettingsNotificationRecipientsRoute,
  }

const DashboardSettingsTenantSettingsRouteWithChildren =
  DashboardSettingsTenantSettingsRoute._addFileChildren(
    DashboardSettingsTenantSettingsRouteChildren,
  )

interface DashboardSettingsRouteChildren {
  DashboardSettingsNotificationsRoute: typeof DashboardSettingsNotificationsRoute
  DashboardSettingsProfileRoute: typeof DashboardSettingsProfileRoute
  DashboardSettingsTenantSettingsRoute: typeof DashboardSettingsTenantSettingsRouteWithChildren
  DashboardSettingsIndexRoute: typeof DashboardSettingsIndexRoute
}

const DashboardSettingsRouteChildren: DashboardSettingsRouteChildren = {
  DashboardSettingsNotificationsRoute: DashboardSettingsNotificationsRoute,
  DashboardSettingsProfileRoute: DashboardSettingsProfileRoute,
  DashboardSettingsTenantSettingsRoute:
    DashboardSettingsTenantSettingsRouteWithChildren,
  DashboardSettingsIndexRoute: DashboardSettingsIndexRoute,
}

const DashboardSettingsRouteWithChildren =
  DashboardSettingsRoute._addFileChildren(DashboardSettingsRouteChildren)

interface DashboardAirLayoutRouteChildren {
  DashboardAirLayoutAutomationSettingsRoute: typeof DashboardAirLayoutAutomationSettingsRoute
  DashboardAirLayoutCaseManagementRoute: typeof DashboardAirLayoutCaseManagementRoute
  DashboardAirLayoutOverviewRoute: typeof DashboardAirLayoutOverviewRoute
  DashboardAirLayoutPolicyManagementRoute: typeof DashboardAirLayoutPolicyManagementRoute
  DashboardAirLayoutIndexRoute: typeof DashboardAirLayoutIndexRoute
}

const DashboardAirLayoutRouteChildren: DashboardAirLayoutRouteChildren = {
  DashboardAirLayoutAutomationSettingsRoute:
    DashboardAirLayoutAutomationSettingsRoute,
  DashboardAirLayoutCaseManagementRoute: DashboardAirLayoutCaseManagementRoute,
  DashboardAirLayoutOverviewRoute: DashboardAirLayoutOverviewRoute,
  DashboardAirLayoutPolicyManagementRoute:
    DashboardAirLayoutPolicyManagementRoute,
  DashboardAirLayoutIndexRoute: DashboardAirLayoutIndexRoute,
}

const DashboardAirLayoutRouteWithChildren =
  DashboardAirLayoutRoute._addFileChildren(DashboardAirLayoutRouteChildren)

interface DashboardMultiTenantLayoutRouteChildren {
  DashboardMultiTenantLayoutAutomationsRoute: typeof DashboardMultiTenantLayoutAutomationsRoute
  DashboardMultiTenantLayoutCasesRoute: typeof DashboardMultiTenantLayoutCasesRoute
  DashboardMultiTenantLayoutPoliciesRoute: typeof DashboardMultiTenantLayoutPoliciesRoute
  DashboardMultiTenantLayoutIndexRoute: typeof DashboardMultiTenantLayoutIndexRoute
}

const DashboardMultiTenantLayoutRouteChildren: DashboardMultiTenantLayoutRouteChildren =
  {
    DashboardMultiTenantLayoutAutomationsRoute:
      DashboardMultiTenantLayoutAutomationsRoute,
    DashboardMultiTenantLayoutCasesRoute: DashboardMultiTenantLayoutCasesRoute,
    DashboardMultiTenantLayoutPoliciesRoute:
      DashboardMultiTenantLayoutPoliciesRoute,
    DashboardMultiTenantLayoutIndexRoute: DashboardMultiTenantLayoutIndexRoute,
  }

const DashboardMultiTenantLayoutRouteWithChildren =
  DashboardMultiTenantLayoutRoute._addFileChildren(
    DashboardMultiTenantLayoutRouteChildren,
  )

interface DashboardAirCaseManagementIdRouteChildren {
  DashboardAirCaseManagementIdAutomationRoute: typeof DashboardAirCaseManagementIdAutomationRoute
  DashboardAirCaseManagementIdBehaviorRoute: typeof DashboardAirCaseManagementIdBehaviorRoute
  DashboardAirCaseManagementIdCaseDetailsRoute: typeof DashboardAirCaseManagementIdCaseDetailsRoute
  DashboardAirCaseManagementIdDiscussionRoute: typeof DashboardAirCaseManagementIdDiscussionRoute
  DashboardAirCaseManagementIdEvidenceRoute: typeof DashboardAirCaseManagementIdEvidenceRoute
  DashboardAirCaseManagementIdInvestigationStepsRoute: typeof DashboardAirCaseManagementIdInvestigationStepsRoute
  DashboardAirCaseManagementIdLogsRoute: typeof DashboardAirCaseManagementIdLogsRoute
  DashboardAirCaseManagementIdOverviewRoute: typeof DashboardAirCaseManagementIdOverviewRoute
  DashboardAirCaseManagementIdIndexRoute: typeof DashboardAirCaseManagementIdIndexRoute
}

const DashboardAirCaseManagementIdRouteChildren: DashboardAirCaseManagementIdRouteChildren =
  {
    DashboardAirCaseManagementIdAutomationRoute:
      DashboardAirCaseManagementIdAutomationRoute,
    DashboardAirCaseManagementIdBehaviorRoute:
      DashboardAirCaseManagementIdBehaviorRoute,
    DashboardAirCaseManagementIdCaseDetailsRoute:
      DashboardAirCaseManagementIdCaseDetailsRoute,
    DashboardAirCaseManagementIdDiscussionRoute:
      DashboardAirCaseManagementIdDiscussionRoute,
    DashboardAirCaseManagementIdEvidenceRoute:
      DashboardAirCaseManagementIdEvidenceRoute,
    DashboardAirCaseManagementIdInvestigationStepsRoute:
      DashboardAirCaseManagementIdInvestigationStepsRoute,
    DashboardAirCaseManagementIdLogsRoute:
      DashboardAirCaseManagementIdLogsRoute,
    DashboardAirCaseManagementIdOverviewRoute:
      DashboardAirCaseManagementIdOverviewRoute,
    DashboardAirCaseManagementIdIndexRoute:
      DashboardAirCaseManagementIdIndexRoute,
  }

const DashboardAirCaseManagementIdRouteWithChildren =
  DashboardAirCaseManagementIdRoute._addFileChildren(
    DashboardAirCaseManagementIdRouteChildren,
  )

interface DashboardRouteChildren {
  DashboardActivityRouteRoute: typeof DashboardActivityRouteRouteWithChildren
  DashboardReportRouteRoute: typeof DashboardReportRouteRouteWithChildren
  DashboardCustomDashboardsRoute: typeof DashboardCustomDashboardsRouteWithChildren
  DashboardGraylogRoute: typeof DashboardGraylogRouteWithChildren
  DashboardHomeRoute: typeof DashboardHomeRoute
  DashboardIntegrationsRoute: typeof DashboardIntegrationsRouteWithChildren
  DashboardMdrRoute: typeof DashboardMdrRouteWithChildren
  DashboardSettingsRoute: typeof DashboardSettingsRouteWithChildren
  DashboardAirLayoutRoute: typeof DashboardAirLayoutRouteWithChildren
  DashboardDevKitchenSinkRoute: typeof DashboardDevKitchenSinkRoute
  DashboardMultiTenantLayoutRoute: typeof DashboardMultiTenantLayoutRouteWithChildren
  DashboardPlaybooksIdRoute: typeof DashboardPlaybooksIdRoute
  DashboardActionsIndexRoute: typeof DashboardActionsIndexRoute
  DashboardPlaybooksIndexRoute: typeof DashboardPlaybooksIndexRoute
  DashboardSearchIndexRoute: typeof DashboardSearchIndexRoute
  DashboardUnauthorizedIndexRoute: typeof DashboardUnauthorizedIndexRoute
  DashboardAirAutomationSettingsMapping_idRoute: typeof DashboardAirAutomationSettingsMapping_idRoute
  DashboardAirAutomationSettingsNewRoute: typeof DashboardAirAutomationSettingsNewRoute
  DashboardAirCaseManagementIdRoute: typeof DashboardAirCaseManagementIdRouteWithChildren
  DashboardAirPolicyManagementPolicyIdRoute: typeof DashboardAirPolicyManagementPolicyIdRoute
  DashboardAirPolicyManagementNewRoute: typeof DashboardAirPolicyManagementNewRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardActivityRouteRoute: DashboardActivityRouteRouteWithChildren,
  DashboardReportRouteRoute: DashboardReportRouteRouteWithChildren,
  DashboardCustomDashboardsRoute: DashboardCustomDashboardsRouteWithChildren,
  DashboardGraylogRoute: DashboardGraylogRouteWithChildren,
  DashboardHomeRoute: DashboardHomeRoute,
  DashboardIntegrationsRoute: DashboardIntegrationsRouteWithChildren,
  DashboardMdrRoute: DashboardMdrRouteWithChildren,
  DashboardSettingsRoute: DashboardSettingsRouteWithChildren,
  DashboardAirLayoutRoute: DashboardAirLayoutRouteWithChildren,
  DashboardDevKitchenSinkRoute: DashboardDevKitchenSinkRoute,
  DashboardMultiTenantLayoutRoute: DashboardMultiTenantLayoutRouteWithChildren,
  DashboardPlaybooksIdRoute: DashboardPlaybooksIdRoute,
  DashboardActionsIndexRoute: DashboardActionsIndexRoute,
  DashboardPlaybooksIndexRoute: DashboardPlaybooksIndexRoute,
  DashboardSearchIndexRoute: DashboardSearchIndexRoute,
  DashboardUnauthorizedIndexRoute: DashboardUnauthorizedIndexRoute,
  DashboardAirAutomationSettingsMapping_idRoute:
    DashboardAirAutomationSettingsMapping_idRoute,
  DashboardAirAutomationSettingsNewRoute:
    DashboardAirAutomationSettingsNewRoute,
  DashboardAirCaseManagementIdRoute:
    DashboardAirCaseManagementIdRouteWithChildren,
  DashboardAirPolicyManagementPolicyIdRoute:
    DashboardAirPolicyManagementPolicyIdRoute,
  DashboardAirPolicyManagementNewRoute: DashboardAirPolicyManagementNewRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  OnboardingRouteRoute: OnboardingRouteRouteWithChildren,
  SignupRouteRoute: SignupRouteRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  DashboardRoute: DashboardRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
